/* Copyright(c) 2019 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */

/*@author Priyanka Patil 5465
 *@fileName : qualityLeadsReview.js
 *Desc: DIQA or DC Lead Review Page 
 */

 import React, { Component } from "react";
 import { withRouter } from "react-router-dom";
 import { logoutUser } from "../login/authentication";
 import PropTypes from "prop-types";
 import { connect } from "react-redux";
 import Navigation from "../layouts/navPage";
 // import Moment from 'react-moment'; //kiran-4752-removing console warning-no used
 import { Table, Select, Tooltip, Icon, Badge } from "antd"; //Aman-4947-added Tooltip, Icon  //5761-Removed unused Input and Button
 import "datatables.net";
 import Footer from "../layouts/footer";
 import Swal from "sweetalert2";
 import { saveAs } from "file-saver";
 import { css } from "emotion";
 import "./qaloginCss.css";
 import { LeadReviewLoader } from "../loaders/LeadReviewLoader"; // Sandeep-task-3441-added loader
 import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; //snehal-task-3724-vAPT URL changes
 //import { width } from 'pdfkit/js/page';
 import styled from "styled-components"; //Aman-4947-added to style tootip
 import { Tabs, Tab } from "react-bootstrap"; //Priyanka-4603
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { token } from "morgan";
import { channel } from "process";
import { assign, unescape } from "underscore";
 const xlsx = require("xlsx");
 const { Option } = Select;
 // const queryString = require('query-string');//kiran-4752-removing console warning-no used
 const tableCSS = css({
   backgroundColor: "white",
   fontFamily: "sans-serif", //sunita-task-3271-added css as per requirement
   borderStyle: "bold",
   // height: "40%", //sunita-task-3271-commneted the css as it's not required.
   "& thead  > tr": {
     backgroundImage: "linear-gradient(to right,#28166f,#007cc3) !important",
     color: "white",
     fontSize: "12px",
     textAlign: "center",
     fontWeight: "500",
   },
   "& thead > tr >th": {
     textAlign: "center",
     color: "white",
   },
 });
 
 //Aman-4947-added to hablde list in tooltip
 /* //snehal-task-2798-UI/UX-Changes-3.1 */
 const HtmlTooltip = styled(Tooltip)`
         backgroundColor: '#f5f5f9',
         color: 'rgba(0, 0, 0, 0.87)',
         maxWidth: 220,
         fontSize: '12px',
         border: '1px solid #dadde9',
         `;
 
       
 // Anshul-5960: added below function to truncate the campaign name in the UI and show full name in tooltip
const truncateText = (text, max = 16) =>
  text && text.length > max ? `${text.slice(0, max)}...` : text || "";


class qualityLeadsReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 1,
      marketingChannel: "",//Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel
      agencyID: "",
      columnUnreadAlertsSearch: ["1", "2", "3"],
      tableSearchText: "", //sunita-task 3271-added this parameter for search functionality.
      unreadAlerts: [],
      unreadAlertsLength: 0,
      campaignList: [],
      loading: " ",
      uploadedFile: [],
      campDetails: [],
      campID: "",
      finalArray: [],
      disable: false,
      diLeadDetails: [],
      tableState: { size: "small" },
      getLeadCounts: "",
      reviewFlag: false,
      pageSize2: 100, //sunita-task-3271-added code for pagination
      leadDetails: [], //sunita-task-3271-added this array for storing campID when we are coming from dashboard.
      leadDetailsSearch:
        [] /* sunita-task-3271- added this array for search functionality*/,
      loading1: false, //sunita-task-3271-added code for loader
      defaultCampID: "", //sunita-task-3271-added code as per requirement
      filesData1: "", //sunita-task-3271-added code for file
      loader2: "", //sandeep--3441-used for loader.
      campList: [],
      campListSearch: [],
      leadDetailsCount: "",
      rejReasonDisplay: "none",
      errors: {},
      reasonErrorDisplayFlag: false,
      reasonErrorDisplayFlag1: false, //Rutuja 5463 reason for diqa rejected leads
      downloadFileLeadsLength: 0, //4788 - Initialize with the default value
      leadStartSelectedDate: "", //Aman-4947-added to store start input Selected date
      leadEndSelectedDate: "", //Aman-4947-added to store end input Selected date
      filterleadDetails: "", //Aman-4947-added to stored filters lead info
      filterleadDetailsCount: "", //Aman-4947-added to stored filters lead info count
      filterleadDetailsSatus: false, //Aman-4947-added to check the status of filter lead and total lead
      stectedStartDateforDisplay: "", //Aman-4947-added to display Selected start date
      stectedEndDateforDisplay: "", //Aman-4947-added to display Selected end date
      selectedDateStart: "", //Aman-4947-added to reset Selected start date from input filed
      selectedDateEnd: "", //Aman-4947-added to reset Selected end date from input filed
      unreadAlerts: "",
      isFileUploadMode:true,//kiran 5775 Prod Issue-DC/DIQA-Lead Review-Error Message and Button Enablement Issue
      isFileUploadCompleted: false,//Kiran 5775 Prod Issue-DC/DIQA-Lead Review-Error Message and Button Enablement Issue
      assignedBy: "", //Anshul-5876/5888:added to store assignedBy value
      showNotesModal: false, //Kiran-5958-Added for internal campaign notes modal
      campaignNotes: "", //Kiran-5958-Added for storing campaign notes
      campaignNotesHistory: [], //Kiran-5958-Added for rendering saved notes in panel
      editingNoteId: null, // Kiran Dhainje 5958 Added for tracking which note is in edit mode
      editingNoteText: "", //Kiran Dhainje 5958 Added for storing the text of the note being edited
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.fileupload = this.fileupload.bind(this);
    this.displayCampaignSpecification =
      this.displayCampaignSpecification.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.displayLeads = this.displayLeads.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);

    this.loadingRef = React.createRef(); // shows the Loader
    this.closeLoadingRef = React.createRef(); // hides the Loader
     this.notesPanelRef = React.createRef();//Kiran Dhainje 5958 Added this 
        this.notesBodyRef = React.createRef();////Kiran Dhainje 5958 Added this 
    //Aman-4947-added startDatedateHandleChange and endDatedateHandleChange to bind
    this.startDatedateHandleChange = this.startDatedateHandleChange.bind(this);
    this.endDatedateHandleChange = this.endDatedateHandleChange.bind(this);
    this.openLinkInBrowser = this.openLinkInBrowser.bind(this); //Nilesh-5051-Add binding method

    this.validateForm1 = this.validateForm1.bind(this); //Rutuja 5463 validating diqa rejected leads reason is entered or not
    this.handleDelete = this.handleDelete.bind(this); //Rutuja 5437
  }

  componentWillMount() {
    if (!this.props.auth.isAuthenticated) {
      this.props.history.push("/userLogin");
    } else {
      this.getFirstTabData();
    } // end of componentwillMount
    //Nilesh-5055- add route for alerts count showing on UI
    fetch("/notification/diqaUnreadAlerts", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((unreadAlerts) => {
        //sunita-task-3271-added below all api code for showing by default campaign id and it's data according to that as this api are alredy present in page jst accessed below as per requirement.
        if (unreadAlerts.length > 0) {
          this.setState({
            unreadAlerts: unreadAlerts
          });
        } else {

        }
      })
      .catch(function (err) {
      });
  }

  
  //Kiran Dhainje 5958 Added below code 
    componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleGlobalClick, true);
    }
  
    componentDidUpdate(prevProps, prevState) {
      const campIDChanged = prevState.campID !== this.state.campID;
  
      if (campIDChanged) {
        this.setState(
          {
            campaignNotesHistory: [],
            campaignNotes: "",
          },
          () => {
            if (this.state.campID) {
              this.getCampaignNotes();
            }
          },
        );
      }
  
      const notesCountChanged =
        prevState.campaignNotesHistory.length !==
        this.state.campaignNotesHistory.length;
      const notesPanelJustOpened =
        !prevState.showNotesModal && this.state.showNotesModal;
  
      if (
        this.state.showNotesModal &&
        (notesCountChanged || notesPanelJustOpened)
      ) {
        this.scrollNotesToBottom();
      }
    }
  
    handleGlobalClick = (event) => {
      if (!this.state.showNotesModal) {
        return;
      }
      if (
        this.notesPanelRef.current &&
        this.notesPanelRef.current.contains(event.target)
      ) {
        return;
      }
      if (event.target.closest(".internal-notes-trigger")) {
        return;
      }
      this.closeNotesModal();
    };
  
    openNotesModal = () => {
      if (!this.state.campID || String(this.state.campID).trim() === "") {
        return;
      }
  
      const isOpening = !this.state.showNotesModal;
  
      this.setState(
        (prevState) => ({
          showNotesModal: !prevState.showNotesModal,
        }),
        () => {
          if (isOpening) {
            this.getCampaignNotes();
          }
        },
      );
    };
  
    closeNotesModal = () => {
      this.setState({ showNotesModal: false });
    };
  
    computeInitials = (text = "") => {
      if (!text) {
        return "DI";
      }
      return text
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((segment) => segment.charAt(0).toUpperCase())
        .join("");
    };
  
    getUserDisplayDetails = () => {
      const authUser = (this.props.auth && this.props.auth.user) || {};
      const nameFromProfile = [authUser.firstName, authUser.lastName]
        .filter(Boolean)
        .join(" ")
        .trim();
      const fallbackName = authUser.userName || authUser.email || "Internal User";
      const displayName = nameFromProfile || fallbackName || "Internal User";
      return {
        name: displayName,
        initials: this.computeInitials(displayName),
      };
    };
  
    resolveNoteUserMeta = (note) => {
      const fallbackMeta = this.getUserDisplayDetails();
      if (!note) {
        return fallbackMeta;
      }
      const senderFullName =
        note.sender_full_name && note.sender_full_name.trim();
      const senderName =
        senderFullName ||
        note.sender_name ||
        note.userName ||
        note.createdBy ||
        note.ownerName;
      const sanitizedName =
        senderName && senderName.trim() ? senderName.trim() : fallbackMeta.name;
  
      const initials =
        note.userInitials ||
        note.sender_initials ||
        this.computeInitials(sanitizedName);
      return { name: sanitizedName, initials };
    };
  
    getOtherUserNotesCount = () => {
      const userId =
        this.props.auth?.user?.userID ||
        this.props.auth?.user?.id ||
        this.props.auth?.user?.userId;
      if (
        !this.state.campaignNotesHistory ||
        this.state.campaignNotesHistory.length === 0
      ) {
        return 0;
      }
      return this.state.campaignNotesHistory.filter((note) => {
        if (!note || note.sender_id === undefined || note.sender_id === null) {
          return false;
        }
        return String(note.sender_id) !== String(userId);
      }).length;
    };
  
    formatTimestamp = (value) => {
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) {
        return typeof value === "string" ? value : "";
      }
      const diff = Date.now() - date.getTime();
      if (diff < 60000) {
        return "Just now";
      }
      if (diff < 3600000) {
        const mins = Math.round(diff / 60000);
        return mins <= 1 ? "1 min ago" : `${mins} mins ago`;
      }
      const today = new Date();
      if (date.toDateString() === today.toDateString()) {
        return date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
        });
      }
      return date.toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
      });
    };
  
    getTimestampLabel = (note) => {
      if (!note) {
        return "";
      }
      const rawTimestamp =
        note.updated_at ||
        note.created_at ||
        note.timestampISO ||
        note.timestamp ||
        note.createdAt ||
        note.date;
      if (!rawTimestamp) {
        return "";
      }
      const formatted = this.formatTimestamp(rawTimestamp);
      if (note.Edited_attempt > 0) {
        return `Edited • ${formatted}`;
      }
      return formatted;
    };
  
    getTimestampTitle = (note) => {
      if (!note) {
        return "";
      }
      const rawTimestamp =
        note.updated_at ||
        note.created_at ||
        note.timestampISO ||
        note.timestamp ||
        note.createdAt ||
        note.date;
      if (!rawTimestamp) {
        return "";
      }
      const date = new Date(rawTimestamp);
      if (Number.isNaN(date.getTime())) {
        return typeof rawTimestamp === "string" ? rawTimestamp : "";
      }
      return date.toLocaleString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    };
  
    scrollNotesToBottom = () => {
      if (this.notesBodyRef.current) {
        this.notesBodyRef.current.scrollTop = 0;
      }
    };
  
    handleNotesChange = (event) => {
      this.setState({ campaignNotes: event.target.value });
    };
  
    handleNotesKeyDown = (event) => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        this.handleSendNotes();
      }
    };
  
    handleSendNotes = async () => {
      const trimmedNote = (this.state.campaignNotes || "").trim();
  
      if (trimmedNote === "") return;
  
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "add",
            campaign_id: this.state.campID,
            sender_id: this.props.auth.user.userID,
            sender_name:
              this.props.auth.user.userName ||
              this.props.auth.user.name ||
              this.props.auth.user.email ||
              "Unknown",
            message: trimmedNote,
          }),
        });
  
        const data = await response.json();
  
        if (data.success) {
          this.setState({ campaignNotes: "" });
          this.getCampaignNotes(); // refresh notes
        }
      } catch (error) {
        console.error("Error adding note:", error);
      }
    };
  
    handleEditNote = (noteId, noteMessage = "") => {
      this.setState({
        editingNoteId: noteId,
        editingNoteText: noteMessage,
      });
    };
  
    handleEditNoteChange = (event) => {
      this.setState({ editingNoteText: event.target.value });
    };
  
    handleEditNoteKeyDown = (event, noteId) => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        this.handleEditNoteSave(noteId);
      }
      if (event.key === "Escape") {
        this.handleEditNoteCancel();
      }
    };
  
    handleEditNoteSave = async (noteId) => {
      const text = this.state.editingNoteText.trim();
      if (!text) return;
  
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "edit",
            campaign_id: this.state.campID,
            note_id: noteId,
            message: text,
            sender_id: this.props.auth.user.userID,
          }),
        });
  
        const data = await response.json();
  
        if (data.success) {
          this.setState({
            editingNoteId: null,
            editingNoteText: "",
          });
  
          this.getCampaignNotes();
        }
      } catch (error) {
        console.error("Edit error:", error);
      }
    };
  
    handleEditNoteCancel = () => {
      this.setState({ editingNoteId: null, editingNoteText: "" });
    };
  
    handleDeleteNote = async (noteId) => {
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "delete",
            campaign_id: this.state.campID,
            note_id: noteId,
            sender_id: this.props.auth.user.userID,
          }),
        });
  
        const data = await response.json();
  
        if (data.success) {
          this.getCampaignNotes();
        }
      } catch (error) {
        console.error("Delete error:", error);
      }
    };
  
    getCampaignNotes = async () => {
      try {
        const response = await fetch("publisher/campaignInternalNotes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "fetch",
            campaign_id: this.state.campID,
          }),
        });
  
        const data = await response.json();
  
        if (data.success) {
          this.setState({
            campaignNotesHistory: data.result || [],
          });
        }
      } catch (error) {
        console.error("Error fetching notes:", error);
      }
    };

  handleSelect(key) {
    this.setState({ key,
      reasonErrorDisplayFlag: false, //Nilesh-5487- Reset error flag
      reasonErrorDisplayFlag1: false, //Nilesh-5487- Reset error flag
     });
    // const { user } = this.props.auth;
    // const { id: agencyID, role: userRole } = user;//kiran-4752-removing console warning-no used
    if (key === 1) {
      this.getFirstTabData();
    } else {
      this.getSecondTabData();
    }
  }

  getFirstTabData() {
    let key = 1;
    this.setState({
      loader2: "loader_review",
      key: key,
      campListSearch: "",
      tableSearchText: "",
    }); //Sandeep-task-3441-added code for loader
    //Priyanka-5467-Displaying Campaign Lists as per role
    if(this.props.auth.user.role === "LC" || this.props.auth.user.role === "LT" ){
      this.getCampaignListDC(key);
    } else {
      this.getCampaignListDIQA(key);
    }
    //this.getLeadTableData(key);
  }
  //kiran-4632-set campListSearch and tableSearchText to empty
  //Priyanka-5467-Added new function to fetch campaign list for DIQA
  getCampaignListDIQA(key) {
    //kiran-4752-removing console warning-changed == to ===
    let self = this;
    if (key === 1) {
      //5425-Chaitanya-Changed leadReviewPV route name to leadReviewDIQA
      fetch("/diQARole/leadReviewDIQA", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => res.json())
        .then((campList) => {
          //sunita-task-3271-added below all api code for showing by default campaign id and it's data according to that as this api are alredy present in page jst accessed below as per requirement.
          if (campList.length > 0) {
            let defaultCampID = campList[0].campID; //sunita-task-3271-added as per requirement
            //Anshul-5876/5888: if role is not 
            const ab = campList[0].assignedBy ?? 'LC';
            this.setState({ campList: campList, campID: defaultCampID, assignedBy: ab }); //sunita-task-3271-setstate for getting updated values
            this.getCampaignInfo(defaultCampID, key);
          } else {
            // kiran-4752-removing console warning-remove duplicate leadDetails
            this.setState({
              loader2: "",
              campList: [],
              campID: "",
              campDetails: [],
              leadDetails: [],
              getLeadCounts: "",
              leadDetailsCount: "",
            });
          }
        })
        .catch(function (err) {
          self.setState({ loading1: false, loader2: "" }); // rutuja Jagtap 4123- added for stoping loader and showing No Data if theier is no data on QA side
        });
    } else {
      //5425-Chaitanya-Changed leadReviewPV route name to leadReviewPVQA
      fetch("/diQARole/leadReviewPVQA", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => res.json())
        .then((campList) => {
          //sunita-task-3271-added below all api code for showing by default campaign id and it's data according to that as this api are alredy present in page jst accessed below as per requirement.
          if (campList.length > 0) {
            let defaultCampID = campList[0].campID; //sunita-task-3271-added as per requirement

            this.setState({ campList: campList, campID: defaultCampID,assignedBy:campList[0].assignedBy }); //sunita-task-3271-setstate for getting updated values
            this.getCampaignInfo(defaultCampID, key);
          } else {
            // kiran-4752-removing console warning-remove duplicate leadDetails
            this.setState({
              loader2: "",
              campList: [],
              campID: "",
              campDetails: [],
              leadDetails: [],
              getLeadCounts: "",
              leadDetailsCount: "",
            });
          }
        })
        .catch(function (err) {
          self.setState({ loading1: false, loader2: "" }); // rutuja Jagtap 4123- added for stoping loader and showing No Data if theier is no data on QA side
        });
    }
  }

  //Priyanka-5467-Added new function to fetch campaign list for DC
  getCampaignListDC(key) {
     // var data = this.props.auth.user.role;
    // console.log("data ==> ", data);
    //kiran-4752-removing console warning-changed == to ===
    if (key === 1) {
       var data ={
            role: this.props.auth.user.role
          }
      fetch("/diQARole/leadReviewDI", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((campList) => {
          //sunita-task-3271-added below all api code for showing by default campaign id and it's data according to that as this api are alredy present in page jst accessed below as per requirement.
          if (campList.length > 0) {
            let defaultCampID = campList[0].campID; //sunita-task-3271-added as per requirement

            this.setState({ campList: campList, campID: defaultCampID }); //sunita-task-3271-setstate for getting updated values
            this.getCampaignInfo(defaultCampID, key);
          } else {
            // kiran-4752-removing console warning-remove duplicate leadDetails
            this.setState({
              loader2: "",
              campList: [],
              campID: "",
              campDetails: [],
              leadDetails: [],
              getLeadCounts: "",
              leadDetailsCount: "",
            });
          }
        })
        .catch(function (err) {
          this.setState({ loading1: false, loader2: "" }); // rutuja Jagtap 4123- added for stoping loader and showing No Data if theier is no data on QA side
        });
    } else {
      fetch("/diQARole/leadReviewPV", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => res.json())
        .then((campList) => {
          //sunita-task-3271-added below all api code for showing by default campaign id and it's data according to that as this api are alredy present in page jst accessed below as per requirement.
          if (campList.length > 0) {
            let defaultCampID = campList[0].campID; //sunita-task-3271-added as per requirement

            this.setState({ campList: campList, campID: defaultCampID }); //sunita-task-3271-setstate for getting updated values
            this.getCampaignInfo(defaultCampID, key);
          } else {
            // kiran-4752-removing console warning-remove duplicate leadDetails
            this.setState({
              loader2: "",
              campList: [],
              campID: "",
              campDetails: [],
              leadDetails: [],
              getLeadCounts: "",
              leadDetailsCount: "",
            });
          }
        })
        .catch(function (err) {
          this.setState({ loading1: false, loader2: "" }); // rutuja Jagtap 4123- added for stoping loader and showing No Data if theier is no data on QA side
        });
    }
  }

  getCampaignInfo(campID, key) {
    this.setState({ filterleadDetailsSatus: false }); //Aman-4947-added to set the filter lead status to false
    // alert("getCampaignInfo");
    let data = { campID: campID };
    //sunita-task-3271-getting right side campaign detail info
    this.setState({ loading1: true, loader2: "loader_review" });
    fetch("/diQARole/getCampDetails", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((campDetails) => {
        //sunita-task-3271-added code for voiceloglink column
        // kiran-4752-removing console warning-changed == to ===
        /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
        if (
          (campDetails[0].marketingChannel === "TeleMarketing" &&
            campDetails[0].callAudit === "Yes") ||
          (campDetails[0].marketingChannel === "Email & Telemarketing" &&
            campDetails[0].callAudit === "Yes")
        ) {
          this.setState({ marketingChannelFlag: true });
        } else {
          this.setState({ marketingChannelFlag: false });
        }
        // Store the raw marketing channel for conditional UI
        //Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel
        this.setState({ marketingChannel: campDetails[0].marketingChannel });

        //Chaitanya-4973-Setting clientName value
        this.setState({
          campDetails: campDetails,
          agencyID: campDetails[0].agencyID,
          reviewFlag: false,
          campID: campID,
          clientName: campDetails[0].clientName,
          clientCampID: campDetails[0].clientCampID, //Chaitanya-5019-Setting clientCampID value
        });
      });
    this.getLeadTableData(campID, key);
  }
 
  getLeadTableData(campID, key) {
    //alert(key);
    //kiran-4752-removing console warning-changed == to ===
    if (key === 1) {
      let data = { campID: campID, role: this.props.auth.user.role, assignedBy: this.state.assignedBy };
      //sunita-task-3271-get downloaded lead count
      fetch("/diQARole/getDIQaLeadCounts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((getDIQaLeadCounts) => {
          if (getDIQaLeadCounts.length > 0) {
            // var campID = getDIQaLeadCounts[0].campID; //kiran-4752-removing console warning-no used
          }

          let cnt = getDIQaLeadCounts.length;
          if (cnt < 0) {
            cnt = 0;
          }
          this.setState({ getLeadCounts: cnt });
        })
        .catch(function (err) {
          console.log(err);
        });

      //sunita-task-3271-display all diqa leads.
      fetch("/diQARole/DIQaleadDetails", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((leadDetails) => {
          let count = leadDetails.length;
          if (count < 0) {
            count = 0;
          }
          // Initialize status field for each lead if not already set Kiran Dhainje 5906 DC/DIQA-Lead Review-Change Instructions and Pass leads to PC-TM/PNC-TM
          leadDetails = leadDetails.map((lead) => ({
            ...lead,
            status: lead.status || "TM VoiceLogReview",
          }));
          this.setState(
            {
              leadDetails: leadDetails,
              leadDetailsCount: count,
              loading1: false,
              loader2: "",
            },
            () => {
              document.getElementById("fileName1").innerHTML =
                "No file Choosen";
            }
          ); //Sandeep-task-2892-added code for to show lead upload file is absence
        })
        .catch(function (err) {
          console.log(err);
        });
    } else {
      let data = { campID: campID };
      //sunita-task-3271-get downloaded lead count
      fetch("/diQARole/getPVLeadCounts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((getPVLeadCounts) => {
          if (getPVLeadCounts.length > 0) {
            // var campID = getPVLeadCounts[0].campID;
          }
          let cnt = getPVLeadCounts.length;
          if (cnt < 0) {
            cnt = 0;
          }
          this.setState({ getLeadCounts: cnt });
        })
        .catch(function (err) {
          console.log(err);
        });

      //sunita-task-3271-display all diqa leads.
      fetch("/diQARole/pvLeadDetails", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((leadDetails) => {
          let count = leadDetails.length;
          if (count < 0) {
            count = 0;
          }
          this.setState(
            {
              leadDetails: leadDetails,
              leadDetailsCount: count,
              loading1: false,
              loader2: "",
            },
            () => {
              document.getElementById("fileName2").innerHTML =
                "No file Choosen";
            }
          ); //Sandeep-task-2892-added code for to show lead upload file is absence
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }
 
  getSecondTabData() {
    //alert("calling getSecondTabData")
    let key = 2;
    //Priyanka-4633-Making all variables null to avoid page to being hang
    this.setState({
      loader2: "loader_review",
      key: key,
      campListSearch: "",
      tableSearchText: "",
      leadDetails: [],
      campList: [],
      leadDetailsCount: "",
      getLeadCounts: "",
    }); //Sandeep-task-3441-added code for loader
    //Priyanka-5467-Displaying Campaign Lists as per role
    if(this.props.auth.user.role === "LC" || this.props.auth.user.role === "LT" ){
      this.getCampaignListDC(key);
    } else {
      this.getCampaignListDIQA(key);
    }
    //this.getLeadTableData(key);
  }
  //kiran-4632-set campListSearch and tableSearchText to empty
  displayLeads(e) {
    e.preventDefault();
    //Aman-4947-added below this.setstate to reset all the filter values
    this.setState({
      filterleadDetailsSatus: false,
      leadStartSelectedDate: "",
      leadEndSelectedDate: "",
      selectedDateStart: "", // Reset input value
      selectedDateEnd: "", // Reset input value
      reasonErrorDisplayFlag: false, //Nilesh-5487- Reset error flag
      reasonErrorDisplayFlag1: false, //Nilesh-5487- Reset error flag
    });
    let key = this.state.key;
    let campID = e.target.id;
    this.getCampaignInfo(campID, key);
  }

  /**
   * @author Rutuja Jagtap
   * @param  Description handle the campaignSpecification on DIQA review lead page
   * @return Description redirect to campaignSpecification page
   */
  displayCampaignSpecification(e) {
    var campID = this.state.campID;
    sessionStorage.setItem("campID", campID);
    window.open("/campaignSpecificationQADashboard");
  }

  handleChangePageSize2 = (e) => {
    const pageSize2 = parseInt(e.target.value); //Nilesh-5517- Convert to number
    this.setState({ pageSize2 }, () => {
   });
  };

  handleChangeSearch(e) {
    e.preventDefault();
    let currentList = [];
    // Variable to hold the filtered list before putting into state
    let newList = [];
    let filterData = e.target.value;
    //alert(filterData)
    // If the search bar isn't empty
    if (e.target.value === "") {
      //alert("if")
      newList = this.state.campList;
    } else {
      //alert("else"+JSON.stringify(this.state.campList))
      // Assign the original list to currentList
      currentList = this.state.campList;
      //alert("currentList-->"+JSON.stringify(currentList))

      newList = currentList.filter((item) => {
        // change current item to lowercase
        const lc = item;
        //const lc = item.toLowerCase();
        // change search term to lowercase
        const filter = e.target.value.toLowerCase();
        //alert("filter-->"+filter)
        // check to see if the current list item includes the search term
        // If it does, it will be added to newList. Using lowercase eliminates
        // issues with capitalization in search terms and search content
        var data = Object.values(lc);
        var dataFinal = data.toString();
        dataFinal = dataFinal.replace(",", " ");
        var dataToLower = dataFinal.toLowerCase();
        //alert("dataToLower-->"+dataToLower)
        return dataToLower.includes(filter);
      });
      //alert("newList-->"+JSON.stringify(newList))
    }
    // Set the filtered state based on what our rules added to newList
    this.setState({
      campListSearch: [...newList],
      tableSearchText: filterData,
    });
  }

  /**
   * @author Sunita Landge
   * @param  Description for voicelog link.
   * @return return the voicelog link data
   */
  //sunita-task-3271-added this handle change for voicelog link
  openLinkInBrowser(e) {
    e.preventDefault();
    var leadInfoID = e.target.id;
    fetch("lead/getVoiceLogLink?leadInfoID=" + leadInfoID + "")
      .then((res) => res.json())
      .then((voiceLogDetails) => {
        this.setState({ voiceLogDetails: voiceLogDetails });
        window.open(voiceLogDetails[0].voiceLogLink, "_blank");
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  // handleChange(i, value, type) {
  //   //kiran-4752-removing console warning-changed == to === and use setState
  //   if (type === "reason") {
  //     let finalArray = [...this.state.leadDetails];
  //     finalArray[i] = { ...finalArray[i], reason: value.target.value };
  //     // this.state.finalArray = [...finalArray];
  //     this.setState({ finalArray: [...finalArray] });
  //     this.setState(
  //       { leadDetails: finalArray, reasonErrorDisplayFlag: false, reasonErrorDisplayFlag1: false }, //Rutuja 5463 if reason entered then flag is false
  //       function () {}
  //     );
  //   }
  //   if (type === "status") {
  //     let finalArray = [...this.state.leadDetails];
  //     finalArray[i] = { ...finalArray[i], status: value };
  //     // this.state.finalArray = [...finalArray];
  //     this.setState({ finalArray: [...finalArray] });
  //     this.setState({ leadDetails: finalArray }, function () {});
  //     if (value === "PV REJECTED") {
  //       this.setState({ reasonErrorDisplayFlag: true });
  //     }
  //     //Rutuja 5463 if status is diqa rejected then flas set to true
  //     else if (value === "DI QA REJECTED"){
  //       this.setState({ reasonErrorDisplayFlag1: true });
  //     }
  //     else {
  //       this.setState({ reasonErrorDisplayFlag: false, reasonErrorDisplayFlag1: false });
  //     }
  //   }
  // }

  //Nilesh-5487- Create a new function for Reason for rejection
  handleReasonChange(absoluteIndex, event) {
    const { name, value } = event.target;
    const updatedDetails = [...this.state.leadDetails];
    const updatedFilterDetails = [...this.state.filterleadDetails];

     //Nilesh-5487- Update the specific field for the record at the absolute index
     updatedDetails[absoluteIndex][name] = value;
     //Nilesh-5516- Also update the filtered list if it is being displayed
     if (this.state.filterleadDetailsSatus) {
      updatedFilterDetails[absoluteIndex][name] = value;
    }

     //Nilesh-5487- Update the state with the modified data source
     this.setState({ leadDetails: updatedDetails,
      filterleadDetails: updatedFilterDetails,
      reasonErrorDisplayFlag: false, 
      reasonErrorDisplayFlag1: false });
  }
  
  //Nilesh-5487- Create a new function for Status
  handleChangeQA(absoluteIndex, event) {

      const { name, value } = event.target;
      const updatedDetails = [...this.state.leadDetails];
      const updatedFilterDetails = [...this.state.filterleadDetails];
    
      //Nilesh-5487- Update the specific field for the record at the absolute index
      updatedDetails[absoluteIndex][name] = value;
      
      // // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
      // Only clear reason when the new status is NOT one of these
      const rejectionStatuses = ["PV REJECTED", "LN QA REJECTED", "TM REJECTED"];
      if (!rejectionStatuses.includes(value)) {
        updatedDetails[absoluteIndex].reason = "";
      }
    
      //Nilesh-5516- Also update the filtered list if it is being displayed
      if (this.state.filterleadDetailsSatus) {
        updatedFilterDetails[absoluteIndex][name] = value;

        //Nilesh-5516- Ensure `reason` is cleared if needed in `filterleadDetails`
        //Rutuja LNQA task
        //// Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
        if (!rejectionStatuses.includes(value)) {
          updatedFilterDetails[absoluteIndex].reason = "";
        }
      }
      //Nilesh-5487- Update the state with the modified data source
      this.setState({ leadDetails: updatedDetails, filterleadDetails: updatedFilterDetails });
      //alert("leadDetails0000 -->" + JSON.stringify(this.state.leadDetails));      
       //alert("filterleadDetails6766 -->" + JSON.stringify(this.state.filterleadDetails));      

      // Set flags for which type of rejection requires a reason
      // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
      if (value === "PV REJECTED") {
        this.setState({ reasonErrorDisplayFlag: true, reasonErrorDisplayFlag1: false });
      } else if (value === "LN QA REJECTED" || value === "TM REJECTED") {
        // DI QA REJECTED and TM REJECTED (for DT role) require reason
        this.setState({ reasonErrorDisplayFlag1: true, reasonErrorDisplayFlag: false });
      } else {
        this.setState({ reasonErrorDisplayFlag: false, reasonErrorDisplayFlag1: false });
      }
    }
 
  onTableChange = (pagination, filters, sorter) => {
    //Nilesh-5487- Update the current page in the state
    this.setState({
      tableState: {
        ...this.state.tableState,
        current: pagination.current, //Nilesh-5487- Update the current page
      },
    });
  }

  handleSubmit() {
     //alert("handleSubmit")
    // const { isAuthenticated, user } = this.props.auth; //kiran-4752-removing console warning-no used
    // Anshul-5960-Added confirmation popup before submit all leads
    Swal.fire({
         title: "Are you sure you want to Submit All leads?",
         type: "question",
         showCancelButton: true,
         confirmButtonText: "Yes",
         confirmButtonColor: "#3085d6",
         cancelButtonText: "Cancel",
         cancelButtonColor: " #d33",
         allowOutsideClick: false,
         reverseButtons: false,
       }).then((result) => {
         if (!result.value) return
    let key = this.state.key;
    if (key === 1) {
      //kiran-4752-removing console warning-changed == to ===
      let updatedLeadDetails = []; // let updatedLeadDetails = this.state.leadDetails
      //Aman-4947-added below condtion to switch between total lead and filter lead to submit data
      if (this.state.filterleadDetailsSatus === false) {
        updatedLeadDetails = this.state.leadDetails;
      } else {
        //Aman-4947-added Extract leadInfoID values from filterleadDetails
        const filterLeadInfoIDs = this.state.filterleadDetails.map(
          (item) => item.leadInfoID
        );

        //Aman-4947-added Filter leadDetails based on matching leadInfoID values
        updatedLeadDetails = this.state.leadDetails.filter((item) =>
          filterLeadInfoIDs.includes(item.leadInfoID)
        ); // alert("updatelead111"+JSON.stringify(updatedLeadDetails));
      }
      // Robust mapping: case-insensitive and trimmed
      // updatedLeadDetails = updatedLeadDetails.map((lead) => {
      //   alert("leadstatus"+JSON.stringify(lead.status))
      //   alert("channel"+JSON.stringify(lead.channel))
      //   alert("leadstatus"+JSON.stringify(updatedLeadDetails))
      //   const status = (lead.status || "").trim().toUpperCase();
      //   const channel = (lead.channel || "").trim().toUpperCase();
      //   const isTMChannel = channel === "Email/TeleMarketing" || channel === "TeleMarketing";
      //   if (isTMChannel && status === "TM Review") {
      //     return { ...lead, status: "DI QA ACCEPTED" };
      //   } else if (isTMChannel && status === "TM REJECTED") {
      //     return { ...lead, status: "TM REJECTED" };
      //   }
      //   return lead;
      // });

      let updatedStatus = [];
      //alert("updatedLeadDetails---->"+JSON.stringify(updatedLeadDetails))
      //Priyanka-4633-Collecting lead status of leads after reviewing
      for (let i = 0; i < updatedLeadDetails.length; i++) {
        updatedStatus.push(updatedLeadDetails[i].status);
      }

      //Rutuja 5463 checking reason is entered againest all lead which are rejected
      if (this.validateForm1() === false) {
        this.setState({
          reasonErrorDisplayFlag1: true,
        });
      }
      else{
      let data = {
        campaignLeadDetails: updatedLeadDetails, //Aman-4947-added updatedLeadDetails intsted of all lead this.state.leadDetails
        campID: this.state.campID,
        //user: user, Priyanka-4580-removing user params
        agencyID: this.state.agencyID,
        clientName: this.state.clientName, //Chaitanya-4973-passing clientName at Submit button
        clientCampID: this.state.clientCampID, //Chaitanya-5019-passing clientCampID at time of file upload
        assignedBy: this.state.assignedBy, 
        marketingChannel: this.state.marketingChannel,
      };
      //this.loadingRef.current.click();//Sandeep-task-3441-added loader
      this.setState({ loading1: true, loader2: "loader_review" });
      fetch("/diQARole/diReviewLeadSubmit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((diLeadDetails) => {
          //this.closeLoadingRef.current.click();//Sandeep-task-3441-added loader
          this.setState({ loading1: false, loader2: "" });
          if (diLeadDetails.length > 0) {
            Swal.fire({
              text: "Lead reviewed successfully",
              type: "success",
              confirmButtonText: "Ok",
              allowOutsideClick: false,

              preConfirm: () => {
                //alert("updatedStatus-->"+updatedStatus)
                //Priyanka-4633-Navigating to second tab if lreviewd leads having PV Review status
                if (updatedStatus.includes("PV Review")) {
                  //alert("if")
                  this.setState({ key: 2 });
                  this.getSecondTabData();
                } else {
                  //alert("else")
                  window.location.reload();
                }
              },
            });
          } else {
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      }
    } else {
      if (this.validateForm() === false) {
        this.setState({
          reasonErrorDisplayFlag: true,
        });
      } else {
        let data = {
          campaignLeadDetails: this.state.leadDetails,
          campID: this.state.campID,
          //user: user, Priyanka-4580-removing user params
          agencyID: this.state.agencyID,
        };
        this.loadingRef.current.click(); //Sandeep-task-3441-added loader
        fetch("/diQARole/pvReviewLeadSubmit", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((pvLeadDetails) => {
            this.closeLoadingRef.current.click(); //Sandeep-task-3441-added loader
            if (pvLeadDetails.length > 0) {
              Swal.fire({
                text: "Lead reviewed successfully",
                type: "success",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
                preConfirm: () => {
                  window.location.reload();
                },
              });
            } else {
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    }  
  }
   );
  }

    /**
   * @author Rutuja Jagtap 5437
   * @param  Description for Rejetecting leads.
   * @return return the sucessfully leads rejected
   */
  handleDelete() {

    let updatedLeadDetails = []; // let updatedLeadDetails = this.state.leadDetails
    //-added below condtion to switch between total lead and filter lead to submit data
    if (this.state.filterleadDetailsSatus === false) {
      updatedLeadDetails = this.state.leadDetails;
    } else {
      //-added Extract leadInfoID values from filterleadDetails
      const filterLeadInfoIDs = this.state.filterleadDetails.map(
        (item) => item.leadInfoID
      );
      //-added Filter leadDetails based on matching leadInfoID values
      updatedLeadDetails = this.state.leadDetails.filter((item) =>
        filterLeadInfoIDs.includes(item.leadInfoID)
      );
    }
    //Ruutja 5463 when click on reject all button pop will be open for entering reason for rejection
    Swal.fire({
      title: "Are you sure you want to Reject All Leads?",
      html:
      
        "<br/><span style='color:red;'><b>*Please enter reason for Rejection</b></span>" +
        "<div><textarea id='rejectReason' rows='2' cols='40'></textarea></div>",
      type: "question",
      showCancelButton: true,
      cancelButtonColor: "#3085d6",
      confirmButtonColor: "#d33",
      allowOutsideClick: false,
      confirmButtonText: "Yes, Reject All Leads!",
    }).then((result) => { 
      if (result.value && document.getElementById("rejectReason").value !== "") {
        var reason = document.getElementById("rejectReason").value;
        // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
        // Set status based on user role: DT uses TM REJECTED, others use DI QA REJECTED
        const userRole = (this.props.auth && this.props.auth.user && this.props.auth.user.role) || "";
        const isDT = userRole.toString().toUpperCase() === "LT";
        const rejectionStatus = isDT ? "TM REJECTED" : "LN QA REJECTED";
        
        // Update all leads with the appropriate rejection status
        updatedLeadDetails = updatedLeadDetails.map((lead) => ({
          ...lead,
          status: rejectionStatus,
        }));

        let data = {
          campaignLeadDetails: updatedLeadDetails, 
          campID: this.state.campID,
          agencyID: this.state.agencyID,
          clientName: this.state.clientName, 
          clientCampID: this.state.clientCampID, 
          reason: reason, //Rutuja 5463 passing reason to BE
        };
        fetch("/diQARole/diRejectLeads", {//Rutuja 5460 chanaged the route spelling from  diRRejectLeads to diRejectLeads
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((diLeadDetails) => {
            this.setState({ loading1: false, loader2: "" });
            if (diLeadDetails.length > 0) {
              Swal.fire({
                text: "Leads Rejected successfully",
                type: "success",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
    
                preConfirm: () => {
                  
                  
                    //alert("else")
                    window.location.reload();
                  
                },
              });
            } else {
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      }
      //Rutuja 5463 if reason not entered and click on yes reject all leads then pop will display
      else {
        if (
          (document.getElementById("rejectReason").value === "" ||
            document.getElementById("rejectReason").value === undefined ||
            document.getElementById("rejectReason").value === null) &&
          result.value === true
        ) {
          Swal.fire({
            text: "Please Enter Reason For Rejection !",
            type: "error",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });
        }
      }
    })

    
  } 
     // 5775 Kiran Dhainje Prod Issue-DC/DIQA-Lead Review-Error Message and Button Enablement Issue
//Commented this fileuplaod function due to many error if change one parameter others getting effected
  // async fileupload(e) {
  //   e.preventDefault();
  //   let key = this.state.key;
  //   if (key === 1) {
  //     //kiran-4752-removing console warning-changed == to ===
  //     this.setState({ loading1: true, loader2: "loader_review" });
  //     let filesData1 = e.target.files[0];
  //     var ext;

  //     await this.fetchDownloadFileLength(); //Chaitanya-4788-fuction call for validation of wrong leads count
  //     var label;
  //     if (filesData1 == null) {
  //       ext = "";
  //       label = document.getElementById("fileName1");
  //       label.innerHTML = "No File Choosen";
  //     } else {
  //       ext = filesData1.name.split(".").pop();
  //       label = document.getElementById("fileName1");
  //       label.innerHTML = filesData1.name;
  //     }

  //     let message = "";
  //     // const { isAuthenticated, user } = this.props.auth;
  //     var data = new FormData();
  //     //kiran-4752-removing console warning-changed == to ===
  //     if (ext === "xlsx" || ext === "XLSX") {
  //       data.append("campID", this.state.campID);
  //       data.append("message", message);
  //       data.append("file", filesData1);
  //       data.append(
  //         "downloadFileLeadsLength",
  //         this.state.downloadFileLeadsLength
  //       );
  //       data.append("clientName", this.state.clientName); //Chaitanya-4973-passing clientName at time of file upload
  //       data.append("clientCampID", this.state.clientCampID); //Chaitanya-5019-passing clientCampID at time of file upload
  //       // Rutuja jagtap 4123 - User Details show in Payload Tab
  //       fetch("/diQARole/uploadReviewLeadDI", {
  //         method: "POST",
  //         body: data,
  //       })
  //         .then((res) => res.json())
  //         .then((campaignLeadDetails) => {
  //           //Chaitanya-4788-Alert for validation of wrong leads count upload in file
  //           if (true === campaignLeadDetails.success) {
  //             Swal.fire({
  //               text: "Leads count in uploaded file is greater than total leads count",
  //               type: "error",
  //               allowOutsideClick: false,
  //               heightAuto: false,
  //               preConfirm: () => {
  //                 window.location.reload();
  //               },
  //             });
  //             return;
  //           }

  //           if (campaignLeadDetails.length > 0) {
  //             //4612-Nilesh-File validation for wrong status upload in file
  //             var temp = [];
  //             for (let i = 0; i < campaignLeadDetails.length; i++) {
  //               temp.push({
  //                 ...this.state.leadDetails[i],
  //                 leadInfoID: campaignLeadDetails[i].leadInfoID,
  //                 email: campaignLeadDetails[i].email,
  //                 jobTitle: campaignLeadDetails[i].jobTitle,
  //                 status: campaignLeadDetails[i].status,
  //                 reason: campaignLeadDetails[i].reason,
  //               });
  //             }
  //             this.setState({
  //               leadDetails: temp,
  //               filterleadDetailsSatus: false,
  //             }); //Aman-4947-added  filterleadDetailsStatus=false to reset filter values
  //             Swal.fire({
  //               text: "File uploaded and leads reviewed",
  //               type: "success",
  //               allowOutsideClick: false,
  //               heightAuto: false,
  //               onOpen: () => {
  //                 this.setState({ reviewFlag: true });
  //                 document.getElementById("submitButton").disabled = true;
  //                 document.getElementById("submitButton1").disabled = true; //sunita-task-3422-added code here for disabling the submit button as only one button get disabled as per requirement done the changes.
  //               },
  //             });
  //           }
  //           //kiran-4752-removing console warning-changed == to ===
  //           else if (false === campaignLeadDetails.success) {
  //             //Nilesh-4770-validation for wrong camp ID upload in file
  //             Swal.fire({
  //               text: campaignLeadDetails.message,
  //               type: "error",
  //               allowOutsideClick: false,
  //               heightAuto: false,
  //               preConfirm: () => {
  //                 window.location.reload();
  //               },
  //             });
  //           } else {
  //             //RUtuja 5463 if while uploading file reason is not entered then pop will display
  //             if (campaignLeadDetails.error == "Please enter reason for Rejection"){
  //               Swal.fire({
  //                 text: "Please enter reason for Rejection", //4612-Nilesh-File validation for wrong status upload in file
  //                 type: "error",
  //                 allowOutsideClick: false,
  //                 heightAuto: false,
  //                 preConfirm: () => {
  //                   window.location.reload();
  //                 },
  //               });
  //             }
  //             else {
  //               Swal.fire({
  //                 text: "Please enter valid status against leads as per the given instructions on the screen", //4612-Nilesh-File validation for wrong status upload in file
  //                 type: "error",
  //                 allowOutsideClick: false,
  //                 heightAuto: false,
  //                 preConfirm: () => {
  //                   window.location.reload();
  //                 },
  //               });
  //             }
             
  //           }
  //           //sunita-task-3271-added below api for removing particular campaign id from left side after file upload
  //           //Priyanka-5467-Added role condition to call route
  //           let route = "";
  //           if(this.props.auth.user.role === "DC"){
  //             route = "/diQARole/leadReviewDI"
  //           } else{
  //             //5425-Chaitanya-Changed leadReviewDI route name to leadReviewDIQA
  //             route = "/diQARole/leadReviewDIQA"
  //           }

  //             fetch(route, {
  //               method: "POST",
  //               headers: { "Content-Type": "application/json" },
  //             })
  //             .then((res) => res.json())
  //               .then((campList) => {
  //                 this.setState({
  //                   campList: campList,
  //                   loading1: false,
  //                   loader2: "",
  //                 });
  //               });
  //             })
  //             .catch(function (err) {
  //               console.log(err);
  //               Swal.fire({
  //                 text: "Error occured please try again",
  //                 type: "error",
  //                 allowOutsideClick: false,
  //                 heightAuto: false,
  //                 preConfirm: () => {
  //                   window.location.reload();
  //                 },
  //               });
  //             });
          
  //     } else {
  //       Swal.fire({
  //         text: "File Invalid Please Upload file with .xlsx format",
  //         type: "error",
  //         allowOutsideClick: false,
  //         heightAuto: false,
  //         preConfirm: () => {
  //           window.location.reload();
  //         },
  //       });
  //     }
  //   } else {
  //     this.setState({ loading1: true, loader2: "loader_review" });
  //     let filesData1 = e.target.files[0];
  //     let ext; //kiran-4752-removing console warning-changed var to let

  //     await this.fetchDownloadFileLengthPV(); //Chaitanya-4788-fuction call for validation of wrong leads count

  //     if (filesData1 == null) {
  //       ext = "";
  //       let label = document.getElementById("fileName2");
  //       label.innerHTML = "No File Choosen";
  //     } else {
  //       ext = filesData1.name.split(".").pop();
  //       let label = document.getElementById("fileName2");
  //       label.innerHTML = filesData1.name;
  //     }

  //     let message = "";
  //     // const { isAuthenticated, user } = this.props.auth;
  //     //kiran-4752-removing console warning-changed var to let and use ===
  //     let data = new FormData();
  //     if (ext === "xlsx" || ext === "XLSX") {
  //       data.append("campID", this.state.campID);
  //       data.append("message", message);
  //       data.append("file", filesData1);
  //       data.append(
  //         "downloadFileLeadsLength",
  //         this.state.downloadFileLeadsLength
  //       );
  //       // Rutuja jagtap 4123 - User Details show in Payload Tab
  //       fetch("/diQARole/uploadReviewLeadPV", {
  //         method: "POST",
  //         body: data,
  //       })
  //         .then((res) => res.json())
  //         .then((campaignLeadDetails) => {
  //           //Chaitanya-4788-Alert for validation of wrong leads count upload in file
  //           if (true === campaignLeadDetails.success) {
  //             Swal.fire({
  //               text: "Leads count in uploaded file is greater than total leads count",
  //               type: "error",
  //               allowOutsideClick: false,
  //               heightAuto: false,
  //               preConfirm: () => {
  //                 window.location.reload();
  //               },
  //             });
  //             return;
  //           }
  //           //kiran-4752-removing console warning-changed == to ===
  //           if (campaignLeadDetails.success === false) {
  //             //4612-Nilesh-File validation for wrong status upload in file
  //             Swal.fire({
  //               text: "Please enter valid status against leads as per the given instructions on the screen",
  //               type: "error",
  //               allowOutsideClick: false,
  //               heightAuto: false,
  //               preConfirm: () => {
  //                 window.location.reload();
  //               },
  //             });
  //           } else if ("success" === campaignLeadDetails.success) {//Nilesh-5038- check else if condition for wrong camp id
  //             //Nilesh-4770-validation for wrong camp ID upload in file
  //             Swal.fire({
  //               text: campaignLeadDetails.message,
  //               type: "error",
  //               allowOutsideClick: false,
  //               heightAuto: false,
  //               preConfirm: () => {
  //                 window.location.reload();
  //               },
  //             });
  //           } else {
  //             if (campaignLeadDetails.length > 0) {
  //               var temp = [];
  //               for (let i = 0; i < campaignLeadDetails.length; i++) {
  //                 temp.push({
  //                   ...this.state.leadDetails[i],
  //                   leadInfoID: campaignLeadDetails[i].leadInfoID,
  //                   email: campaignLeadDetails[i].email,
  //                   jobTitle: campaignLeadDetails[i].jobTitle,
  //                   status: campaignLeadDetails[i].status,
  //                   reason: campaignLeadDetails[i].reason,
  //                 });
  //               }
  //               this.setState({ leadDetails: temp });
  //               Swal.fire({
  //                 text: "File uploaded and leads reviewed",
  //                 type: "success",
  //                 allowOutsideClick: false,
  //                 heightAuto: false,
  //                 onOpen: () => {
  //                   this.setState({ reviewFlag: true });
  //                   //Priyanka-4633-Disabling Submit button after uploading file
  //                   document.getElementById("submitButtonPV").disabled = true;
  //                   document.getElementById("submitButtonPV1").disabled = true;
  //                 },
  //               });

  //               //sunita-task-3271-added below api for removing particular campaign id from left side after file upload
  //               //Priyanka-5467-Added role condition to call route
  //           let route = "";
  //           if(this.props.auth.user.role === "DC"){
  //             route = "/diQARole/leadReviewPV"
  //           } else{
  //             //5425-Chaitanya-Changed leadReviewPV route name to leadReviewPVQA
  //             route = "/diQARole/leadReviewPVQA"
  //           }
  //           fetch(route, {
  //                 method: "POST",
  //                 headers: { "Content-Type": "application/json" },
  //               })
  //                 .then((res) => res.json())
  //                 .then((campList) => {
  //                   this.setState({
  //                     campList: campList,
  //                     loading1: false,
  //                     loader2: "",
  //                   });
  //                 });
  //             } else {
  //               Swal.fire({
  //                 text: "Please enter reason for Rejection",
  //                 type: "error",
  //                 allowOutsideClick: false,
  //                 heightAuto: false,
  //                 preConfirm: () => {
  //                   window.location.reload();
  //                 },
  //               });
  //             }
  //           }
  //         })
  //         .catch(function (err) {
  //           Swal.fire({
  //             text: "Error occured please try again",
  //             type: "error",
  //             allowOutsideClick: false,
  //             heightAuto: false,
  //             preConfirm: () => {
  //               window.location.reload();
  //             },
  //           });
  //         });
  //     } else {
  //       //Nilesh-4770- Add xlsx file validation
  //       Swal.fire({
  //         text: "File Invalid Please Upload file with .xlsx format",
  //         type: "error",
  //         allowOutsideClick: false,
  //         heightAuto: false,
  //         preConfirm: () => {
  //           window.location.reload();
  //         },
  //       });
  //     }
  //   }
  // }

     // 5775 Kiran Dhainje Prod Issue-DC/DIQA-Lead Review-Error Message and Button Enablement Issue
     //rewrite the function cause of many error if change one parameter others getting effected
  async fileupload(e) {
  e.preventDefault();
  let key = this.state.key;

  //  Always mark upload mode at start
  this.setState({
    loading1: true,
    loader2: "loader_review",
    isFileUploadMode: true,
     isFileUploadCompleted: true ,
    reasonErrorDisplayFlag: false,
    reasonErrorDisplayFlag1: false
  });


  // document.getElementById("submitButton").disabled = true;
  // document.getElementById("submitButton1").disabled = true;
  // document.getElementById("submitButtonPV").disabled = true;
  // document.getElementById("submitButtonPV1").disabled = true;

  if (key === 1) {
    let filesData1 = e.target.files[0];
    var ext;

    await this.fetchDownloadFileLength();
    var label;
    if (filesData1 == null) {
      ext = "";
      label = document.getElementById("fileName1");
      label.innerHTML = "No File Choosen";
    } else {
      ext = filesData1.name.split(".").pop();
      label = document.getElementById("fileName1");
      label.innerHTML = filesData1.name;
    }

    let message = "";
    var data = new FormData();

    if (ext === "xlsx" || ext === "XLSX") {
      data.append("campID", this.state.campID);
      data.append("message", message);
      data.append("file", filesData1);
      data.append("downloadFileLeadsLength", this.state.downloadFileLeadsLength);
      data.append("clientName", this.state.clientName);
      data.append("clientCampID", this.state.clientCampID);
      data.append("mrkChn",(this.state.campDetails[0].marketingChannel));//Kiran Dhainje 5847 DT -Display Campaigns, Leads and DIQA users for Email Marketing Channel
      data.append("assignedBy", this.state.assignedBy);//Kiran Dhainje 5847 DT -Display Campaigns, Leads and DIQA users for Email Marketing Channel

      fetch("/diQARole/uploadReviewLeadDI", {
        method: "POST",
        body: data,
      })
        .then((res) => res.json())
        .then((campaignLeadDetails) => {
          if (true === campaignLeadDetails.success) {
            Swal.fire({
              text: "Leads count in uploaded file is greater than total leads count",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
            return;
          }

          // Handle DT role validation error from backend
          //Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
          if (campaignLeadDetails.error) {
            Swal.fire({
              text: campaignLeadDetails.error,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
            return;
          }

          if (campaignLeadDetails.length > 0) {
            var temp = [];
            for (let i = 0; i < campaignLeadDetails.length; i++) {
              temp.push({
                ...this.state.leadDetails[i],
                leadInfoID: campaignLeadDetails[i].leadInfoID,
                email: campaignLeadDetails[i].email,
                jobTitle: campaignLeadDetails[i].jobTitle,
                status: campaignLeadDetails[i].status,
                reason: campaignLeadDetails[i].reason,
              });
            }
            this.setState({
              leadDetails: temp,
              filterleadDetailsSatus: false,
            });
            Swal.fire({
              text: "Leads reviewed successfully",
              type: "success",
              allowOutsideClick: false,
              heightAuto: false,
              onOpen: () => {
              this.setState({ reviewFlag: true,  isFileUploadCompleted: true  });
               
                // document.getElementById("submitButton").disabled = true;
                // document.getElementById("submitButton1").disabled = true;
              },
            });
          } else if (false === campaignLeadDetails.success) {
            Swal.fire({
              text: campaignLeadDetails.message,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          } else {
            // Suppress rejection-specific message, show generic error
            Swal.fire({
              text: "Please enter valid status against leads as per the given instructions on the screen",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          }

          // Refresh left-side campaign list
          //Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
          let route = "";
        if (this.props.auth.user.role === "LC" || this.props.auth.user.role === "LT") {
            route = "/diQARole/leadReviewDI";
          } else {
            route = "/diQARole/leadReviewDIQA";
          }
          var data ={
            role: this.props.auth.user.role
          }
          //console.log("data ==> ", data);
          fetch(route, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((campList) => {
              this.setState({
                campList: campList,
                loading1: false,
                loader2: "",
              });
            });
        })
        .catch(function (err) {
          console.log(err);
          Swal.fire({
            text: "Error occured please try again",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        });
    } else {
      Swal.fire({
        text: "File Invalid Please Upload file with .xlsx format",
        type: "error",
        allowOutsideClick: false,
        heightAuto: false,
        preConfirm: () => {
          window.location.reload();
        },
      });
    }
  } else {
    // --------- PV tab upload (same adjustments applied) ----------
    let filesData1 = e.target.files[0];
    let ext;

    await this.fetchDownloadFileLengthPV();

    if (filesData1 == null) {
      ext = "";
      let label = document.getElementById("fileName2");
      label.innerHTML = "No File Choosen";
    } else {
      ext = filesData1.name.split(".").pop();
      let label = document.getElementById("fileName2");
      label.innerHTML = filesData1.name;
    }

    let message = "";
    let data = new FormData();
    if (ext === "xlsx" || ext === "XLSX") {
      data.append("campID", this.state.campID);
      data.append("message", message);
      data.append("file", filesData1);
      data.append("downloadFileLeadsLength", this.state.downloadFileLeadsLength);

      fetch("/diQARole/uploadReviewLeadPV", {
        method: "POST",
        body: data,
      })
        .then((res) => res.json())
        .then((campaignLeadDetails) => {
          if (true === campaignLeadDetails.success) {
            Swal.fire({
              text: "Leads count in uploaded file is greater than total leads count",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
            return;
          }
          if (campaignLeadDetails.success === false) {
            Swal.fire({
              text: "Please enter valid status against leads as per the given instructions on the screen",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          } else if ("success" === campaignLeadDetails.success) {
            Swal.fire({
              text: campaignLeadDetails.message,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          } else {
            if (campaignLeadDetails.length > 0) {
              var temp = [];
              for (let i = 0; i < campaignLeadDetails.length; i++) {
                temp.push({
                  ...this.state.leadDetails[i],
                  leadInfoID: campaignLeadDetails[i].leadInfoID,
                  email: campaignLeadDetails[i].email,
                  jobTitle: campaignLeadDetails[i].jobTitle,
                  status: campaignLeadDetails[i].status,
                  reason: campaignLeadDetails[i].reason,
                });
              }
              this.setState({ leadDetails: temp });
              Swal.fire({
                text: "Leads reviewed successfully",
                type: "success",
                allowOutsideClick: false,
                heightAuto: false,
                onOpen: () => {
                 this.setState({ reviewFlag: true, isFileUploadCompleted: true });
                  
                  // document.getElementById("submitButtonPV").disabled = true;
                  // document.getElementById("submitButtonPV1").disabled = true;
                },
              });

              // Refresh left-side campaign list
              //Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
              let route = "";
              if (this.props.auth.user.role === "LC" || this.props.auth.user.role === "LT" ) {
                route = "/diQARole/leadReviewPV";
              } else {
                route = "/diQARole/leadReviewPVQA";
              }
              fetch(route, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
              })
                .then((res) => res.json())
                .then((campList) => {
                  this.setState({
                    campList: campList,
                    loading1: false,
                    loader2: "",
                  });
                });
            } else {
             
              Swal.fire({
                text: "Please enter valid status against leads as per the given instructions on the screen",
                type: "error",
                allowOutsideClick: false,
                heightAuto: false,
                preConfirm: () => {
                  window.location.reload();
                },
              });
            }
          }
        })
        .catch(function (err) {
          Swal.fire({
            text: "Error occured please try again",
            type: "error",
            allowOutsideClick: false,
            heightAuto: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        });
    } else {
      Swal.fire({
        text: "File Invalid Please Upload file with .xlsx format",
        type: "error",
        allowOutsideClick: false,
        heightAuto: false,
        preConfirm: () => {
          window.location.reload();
        },
      });
    }
  }
}

  downloadFile(e) {
    let errors = {};
    // var parsed = queryString.parse(this.props.location.search);
    // let data = {
    //   campID: this.state.campID,
    // }//kiran-4752-removing console warning-no used
    let campList = this.state.campList; //4588-Nilesh File Naming convention change
    let campDetail = campList.filter((el) => {
      return el.campID == this.state.campID; //kiran-4752-not resolved giving issue while file download
    });
    let key = this.state.key;
    //kiran-4752-removing console warning-changed == to ===
    if (key === 1) {
      //Aman-4947-added  condition to check filter lead and total lead to download lead file else will download filter lead
      if (this.state.filterleadDetailsSatus === false) {
        Swal.fire({
          onOpen: () => {
            Swal.showLoading();
            const data = {
              campID: this.state.campID,
              assignedBy: this.state.assignedBy,
              marketingChannel: this.state.marketingChannel,
            };

            const params = new URLSearchParams({
              
              ...data
            });
            //Anshul-5876/5888: change route calling to send assigned by and marketing channel
            fetch(
              // "/diQARole/downloadLeadDetails?campID=" + this.state.campID + ""
              `/diQARole/downloadLeadDetails?${params.toString()}`
            )
              .then((res) => res.json())
              .then((downloadFiles) => {
                this.setState({ downloadFiles: downloadFiles });
                if (downloadFiles.success === true) {
                  Swal.fire({
                    type: "error",
                    text: "No Data Exists!",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                  });
                  this.setState({ errors: errors });
                } else {
                  var ws = xlsx.utils.json_to_sheet(downloadFiles);
                  var wb = xlsx.utils.book_new();
                  xlsx.utils.book_append_sheet(wb, ws, "Lead");
                  var buf = xlsx.write(wb, {
                    bookType: "xlsx",
                    type: "buffer",
                  }); // generate a nodejs buffer
                  var str = xlsx.write(wb, { bookType: 'xlsx', type: 'binary' });//kiran-4752-removing console warning-no used
                  function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i)
                      view[i] = s.charCodeAt(i) & 0xff;
                    return buf;
                  }
                  var fileName = this.state.campID + "_QA_Leads" + ".xlsx";
                  var fileName =
                    "LN_QA_Leads_" +
                    campDetail[0].clientCampID +
                    "_" +
                    this.state.campID +
                    ".xlsx"; //4588-Nilesh File Naming convention change
                  saveAs(
                    new Blob([s2ab(buf)], { type: "application/octet-stream" }),
                    fileName
                  );
                  Swal.fire({
                    text: "File Downloaded Successfully",
                    type: "success",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                  });
                  const records = downloadFiles;
                  if (!Array.isArray(records) || records.length === 0) {
                    Swal.fire({ type: "warning", text: "No Data Exists!" });
                    return;
                  }

                }
              });
          },
        });
      } else {
        Swal.fire({
          onOpen: () => {
            Swal.showLoading();
            let data = {
              campID: this.state.campID,
              startData: this.state.leadStartSelectedDate,
              endDate: this.state.leadEndSelectedDate,
              role: this.props.auth.user.role,
              assignedBy: this.state.assignedBy, //Anshul-5977: send assignedBy for filtered download as well
            };
            fetch("/diQARole/downloadLeadDetailsFilter", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(data),
            })
              .then((res) => res.json())
              .then((downloadFiles) => {
                this.setState({ downloadFiles: downloadFiles });

                if (downloadFiles.success === true) {
                  Swal.fire({
                    type: "error",
                    text: "No Data Exists!",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                  });
                  this.setState({ errors: errors });
                }else {
                  var ws = xlsx.utils.json_to_sheet(downloadFiles);
                  var wb = xlsx.utils.book_new();
                  xlsx.utils.book_append_sheet(wb, ws, "Lead");
                  var buf = xlsx.write(wb, {
                    bookType: "xlsx",
                    type: "buffer",
                  }); // generate a nodejs buffer
                  // var str = xlsx.write(wb, { bookType: 'xlsx', type: 'binary' });//kiran-4752-removing console warning-no used
                  function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i !== s.length; ++i)
                      view[i] = s.charCodeAt(i) & 0xff;
                    return buf;
                  }
                  //var fileName = this.state.campID + "_QA_Leads" + ".xlsx";
                  var fileName =
                    "LN_QA_Leads_" +
                    campDetail[0].clientCampID +
                    "_" +
                    this.state.campID +
                    ".xlsx"; //4588-Nilesh File Naming convention change
                  saveAs(
                    new Blob([s2ab(buf)], { type: "application/octet-stream" }),
                    fileName
                  );
                }
              });
          },
        });
      }
    } else {
      Swal.fire({
        onOpen: () => {
          Swal.showLoading();
          fetch(
            "/diQARole/downloadLeadDetailsPV?campID=" + this.state.campID + ""
          )
            .then((res) => res.json())
            .then((downloadFiles) => {
              this.setState({ downloadFiles: downloadFiles });

              if (downloadFiles.success === true) {
                Swal.fire({
                  type: "error",
                  text: "No Data Exists!",
                  confirmButtonText: "Ok",
                  allowOutsideClick: false,
                });
                this.setState({ errors: errors });
              } else {
                var ws = xlsx.utils.json_to_sheet(downloadFiles);
                var wb = xlsx.utils.book_new();
                xlsx.utils.book_append_sheet(wb, ws, "Lead");
                var buf = xlsx.write(wb, { bookType: "xlsx", type: "buffer" }); // generate a nodejs buffer
                //  var str = xlsx.write(wb, { bookType: 'xlsx', type: 'binary' });
                function s2ab(s) {
                  var buf = new ArrayBuffer(s.length);
                  var view = new Uint8Array(buf);
                  //kiran-4752-changed != to !==
                  for (var i = 0; i !== s.length; ++i)
                    view[i] = s.charCodeAt(i) & 0xff;
                  return buf;
                }
                //var fileName = this.state.campID + "_QA_Leads" + ".xlsx";
                var fileName =
                  "PV_Leads_" +
                  campDetail[0].clientCampID +
                  "_" +
                  this.state.campID +
                  ".xlsx"; //4588-Nilesh File Naming convention change
                saveAs(
                  new Blob([s2ab(buf)], { type: "application/octet-stream" }),
                  fileName
                );
                  Swal.close();//Anshul-6022: close the loading alert before showing success alert
                Swal.fire({
                  text: "File Downloaded Successfully",
                  type: "success",
                  confirmButtonText: "Ok",
                  allowOutsideClick: false,
                });
              }
            });
        },
      });
    }
  }

  validateForm() {
    let formIsvalid = true;
    for (let i = 0; i < this.state.leadDetails.length; i++) {
      if (
        this.state.leadDetails[i].status === "PV REJECTED" &&
        (this.state.leadDetails[i].reason === undefined ||
          this.state.leadDetails[i].reason === "" ||
          this.state.leadDetails[i].reason === " ")
      ) {
        formIsvalid = false;
      }
    }
    return formIsvalid;
  }

  //Rutuja  5463 function will return formavalid false if rejecting leads manually and nt entered reason
  validateForm1() {
    let formIsvalid = true;
    // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
    const userRole = (this.props.auth && this.props.auth.user && this.props.auth.user.role) || "";
    const isDT = userRole.toString().toUpperCase() === "LT";
    for (let i = 0; i < this.state.leadDetails.length; i++) {
      const status = this.state.leadDetails[i].status;
      const needsReason =
        status === "LN QA REJECTED" || (isDT && status === "TM REJECTED");
      if (
        needsReason &&
        (this.state.leadDetails[i].reason === undefined ||
          this.state.leadDetails[i].reason === "" ||
          this.state.leadDetails[i].reason === " ")
      ) {
        formIsvalid = false;
      }
    }
    return formIsvalid;
  }

  //Chaitanya-4788-fuction for validation of wrong leads count upload in file
  async fetchDownloadFileLength() {
    const campID = this.state.campID;
    let data1 = {
      campID: this.state.campID,
      assignedBy: this.state.assignedBy,
    };
    try {
      const data = {
        campID:this.state.campID,
        assignedBy: this.state.assignedBy,
        marketingChannel:this.state.marketingChannel
      };

      const params = new URLSearchParams({
        ...data
      });
      //Anshul-5876/5888: changed route call to send mar
      const response = await fetch(
        // "/diQARole/downloadLeadDetails?campID=" + campID
        `/diQARole/downloadLeadDetails?${params.toString()}`
      );
      const downloadFiles1 = await response.json();

      var downloadFileLeadsLength = downloadFiles1.length;
      //Aman-4947-added to switch between the filter and total lead count length
      if (this.state.filterleadDetailsSatus === false) {
        this.setState({ downloadFileLeadsLength: downloadFileLeadsLength });
      } else {
        this.setState({
          downloadFileLeadsLength: this.state.filterleadDetailsCount,
        });
      }
    } catch (error) {
      console.error("Error fetching download files:", error);
    }
  }
  //Chaitanya-4788-fuction for validation of wrong leads count upload in file
  async fetchDownloadFileLengthPV() {
    const campID = this.state.campID;
    try {
      const response = await fetch(
        "/diQARole/downloadLeadDetailsPV?campID=" + campID
      );
      const downloadFiles1 = await response.json();

      var downloadFileLeadsLength = downloadFiles1.length;
      this.setState({ downloadFileLeadsLength: downloadFileLeadsLength });
    } catch (error) {
      console.error("Error fetching download files:", error);
    }
  }

  //Aman-4947-added startDatedateHandleChange to handle the lead startSelectedDate date
 startDatedateHandleChange(e) {
    e.preventDefault();
    // var startSelectedDate = e.target.value;
    var startSelectedDate = e.target.value || ""; //Nilesh-5890

    this.setState({ leadStartSelectedDate: startSelectedDate }, () => {
      this.filterleadByStartAndEndDate();
    });

    // const reversedDate = this.reverseDateFormat(startSelectedDate); //Aman-4947 Output: "17-01-2024"
    //Nilesh-5890
    const reversedDate = startSelectedDate
      ? this.reverseDateFormat(startSelectedDate)
      : "";

    this.setState({
      stectedStartDateforDisplay: reversedDate,
      selectedDateStart: startSelectedDate, //Aman-4947 Update state variable for input value
    });
  }
  //Aman-4947-added endDatedateHandleChange to handle the lead endSelectedDate date
   endDatedateHandleChange(e) {
    e.preventDefault();
    // var endSelectedDate = e.target.value;
    var endSelectedDate = e.target.value || ""; //Nilesh-5890
    this.setState({ leadEndSelectedDate: endSelectedDate }, () => {
      this.filterleadByStartAndEndDate();
    });

// const reversedDate = this.reverseDateFormat(endSelectedDate); ////Aman-4947- Output: "17-01-2024"
    //Nilesh-5890
    const reversedDate = endSelectedDate
      ? this.reverseDateFormat(endSelectedDate)
      : "";
      this.setState({
      stectedEndDateforDisplay: reversedDate,
      selectedDateEnd: endSelectedDate, ////Aman-4947- Update state variable for input value
    });
  }

  //Aman-4947-added filterleadByStartAndEndDate to get filter lead from BE and return filter lead as per the date
  filterleadByStartAndEndDate(e) {
    if (
      this.state.leadStartSelectedDate !== "" &&
      this.state.leadEndSelectedDate !== ""
    ) {
      this.setState({ loading1: true, loader2: "loader_review" });
      let data = {
        campID: this.state.campID,
        startData: this.state.leadStartSelectedDate,
        endDate: this.state.leadEndSelectedDate,
        assignedBy: this.state.assignedBy, //Anshul-5876/5888:added assignedBy
        role: this.props.auth.user.role, //Nilesh-5890-added role      
        };
      //sunita-task-3271-display all diqa leads.
      fetch("/diQARole/DIQaLeadDetailsFilter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((leadDetails) => {
          let count = leadDetails.length;
          if (count < 0) {
            count = 0;
          }
          //alert("leadDetails => "+leadDetails)
          this.setState({
            filterleadDetails: leadDetails,
            filterleadDetailsCount: count,
            loading1: false,
            loader2: "",
            filterleadDetailsSatus: true,
            reasonErrorDisplayFlag: false,
            reasonErrorDisplayFlag1: false
            // leadStartSelectedDate: "",
            // leadEndSelectedDate: "",
          });
        })
        .catch(function (err) {
          console.log(err);
        });
    } else {
    }
  }

  //Aman-4947-added reverseDateFormat to format the selected date to display correct oder
  reverseDateFormat(originalDate) {
    //Aman-4947-added Split the original date string
    const dateParts = originalDate.split("-");

    //Aman-4947-added Rearrange the parts in the desired order
    const reversedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

    return reversedDate;
  }

 //Nilesh-5055- This function calling for new page
  unreadAlerts(e) {
    e.preventDefault();
    this.props.history.push("/qaUnreadAlerts"); //Rutuja LNQA task
  }

  render() {
     const otherNotesCount = this.getOtherUserNotesCount();//Kiran 5958 Added this to fetch count 
    //sunita-task-3271- below all qaLeadDetails cloumns ,qaLeadDetails2 columns  are used for antd table
    const qaLeadDetails = [
        {
          title: "Lead ID",
          dataIndex: "leadInfoID",
          key: "leadInfoID",
          width: "8%",
          align: "Center", //Sandeep-task-3441
          render: (
            text,
            record //sunita-task-3271-added below code as per requirement
          ) => (
            <div>
              <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
                {record.leadInfoID}
              </span>
            </div>
          ),
        },
        {
          title: "Email",
          dataIndex: "email",
          key: "email",
          width: "17%",
          align: "Center", //Sandeep-task-3441
  
          render: (
            text,
            record //sunita-task-3271-added below code as per requirement
          ) => (
            <div>
              <span
                style={{
                  fontSize: "13px",
                  color: "#4F4F4F",
                  wordBreak: "break-all",
                }}
                title={record.email}
              >
                {record.email}
              </span>
            </div>
          ),
        },
        // Chaitanya-5838-Added column for leadInteractionDate
        {
          title: "Lead Interaction Date",
          dataIndex: "leadInteractionDate",
          key: "leadInteractionDate",
          width: "12%",
          align: "Center",
          render: (text, record) => <div>{record.leadInteractionDate}</div>,
        },
        {
          title: "Job Title",
          dataIndex: "jobTitle",
          key: "jobTitle",
          width: "21%",
          align: "Center", //Sandeep-task-3441
  
          render: (
            text,
            record //sunita-task-3271-added below code as per requirement
          ) => (
            <div>
              <span style={{ fontSize: "13px", color: "#4F4F4F" }}title={record.jobTitle}>
                {record.jobTitle}
              </span>
            </div>
          ),
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          width: "21%",
          align: "left", //Sandeep-task-3441
          render: (text, record, i) => {
            const pageSize = this.state.pageSize2; //Nilesh-5487- Number of rows per page
            const currentPage = this.state.tableState.current || 1; //Nilesh-5487- Current page
            const absoluteIndex = (currentPage - 1) * pageSize + i; //Nilesh-5487- Calculate absolute index
        
            return (
              <div>
                <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
                  {this.state.reviewFlag === true ? (
                    <label>{text}</label>
                  ) : (
                    // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
                      //Anshul-5876/5888:Updated dropdown UI
                      /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
                      (() => {
                        const mc = (this.state.marketingChannel || "").toLowerCase();
                        if (mc === "Email & Telemarketing" || mc === "Telemarketing" || mc.includes("tele")) {
                          if ((this.props.auth.user.role == 'LC') || (this.props.auth.user.role == 'LNQA' && this.state.assignedBy == 'LC')){
                            return (
                              <select
                                style={{ height: "60%", width: "100%" }}
                                id="status"
                                name="status"
                                value={record.status || "TM VoiceLogReview"}
                                onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                                className="form-control"
                              >{/* Kiran Dhainje 5906 DC/DIQA-Lead Review-Change Instructions and Change TM Review to TM VoiceLogReview */}
                                <option value="TM VoiceLogReview">TM VoiceLogReview</option>
                                <option value="LN QA REJECTED">LN QA REJECTED</option>
                              </select>
                            );
                          } else if ((this.props.auth.user.role == 'LT') || (this.props.auth.user.role == 'LNQA' && this.state.assignedBy == 'LT')){
                            return (
                              <select
                                style={{ height: "60%", width: "100%" }}
                                id="status"
                                name="status"
                                value={record.status || "TM ACCEPTED"}
                                onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                                className="form-control"
                              >
                                <option value="TM ACCEPTED">TM ACCEPTED</option>
                                <option value="TM REJECTED">TM REJECTED</option>
                              </select>
                            );
                          } 
                      }else if(mc == 'email'){
                          return (
                            <select
                              style={{ height: "60%", width: "100%" }}
                              id="status"
                              name="status"
                              value={record.status || "TM ACCEPTED"}
                              onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                              className="form-control"
                            >
                              <option value="LN QA ACCEPTED">LN QA ACCEPTED</option>
                              <option value="LN QA REJECTED">LN QA REJECTED</option>
                            </select>
                          );
                      }else if(mc == 'telemarketing'){
                          return (
                            <select
                              style={{ height: "60%", width: "100%" }}
                              id="status"
                              name="status"
                              value={record.status || "TM ACCEPTED"}
                              onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                              className="form-control"
                            >
                              <option value="TM ACCEPTED">TM ACCEPTED</option>
                              <option value="TM REJECTED">TM REJECTED</option>
                            </select>
                          );
                      }
                     
                    })()
                  )}
                </span>
              </div>
            )
          }
        },
        {
          title: "Reason For Rejection", //Sandeep-task-3441
          dataIndex: "reason",
          key: "reason",
          width: "21%",
          align: "left", //Sandeep-task-3441
          render: (text, record, i) => {
            const pageSize = this.state.pageSize2;
            const currentPage = this.state.tableState.current || 1;
            const absoluteIndex = (currentPage - 1) * pageSize + i;
            return (
            <div
              className="mywidth"
              style={{ fontSize: "13px", color: "#4F4F4F" }}
            >
              {this.state.reviewFlag === true ? (
                <label>{text}</label>
              ) : (
                <input
                  type="text"
                  id={`reason-${absoluteIndex}`} //Nilesh-5487- Unique ID for the input
                  name="reason"
                  value={record.reason || ""} //Nilesh-5487- Bind to the dataset value
                  disabled={record.status !== "LN QA REJECTED" && record.status !== "TM REJECTED"} //Kiran 5860-5848 - Enable for both "DI QA REJECTED" and "TM REJECTED"
                  onChange={(e) => this.handleReasonChange(absoluteIndex, e)}
                  className="form-control"
                />
              )}
              </div>
            );
          }
        },
    ];
  
    //sunita-task-3271- below all qaLeadDetails2 are used for antd table columns same as above only added one extra column for voicelog link
    const qaLeadDetails2 = [
    {
        title: "Lead ID",
        dataIndex: "leadInfoID",
        key: "leadInfoID",
        width: "8%",
        align: "Center", //Sandeep-task-3441
        render: (
        text,
        record //sunita-task-3271-added below code as per requirement
        ) => (
        <div>
            <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
            {record.leadInfoID}
            </span>
        </div>
        ),
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "17%",
        align: "Center", //Sandeep-task-3441

        render: (
        text,
        record //sunita-task-3271-added below code as per requirement
        ) => (
        <div>
            {/* <span style={{ fontSize: '11px',wordBreak: "break-all" }}> */}
            <span
            style={{
                fontSize: "13px",
                color: "#4F4F4F",
                wordBreak: "break-all",
            }}
            title={record.email}
            >
            {record.email}
            </span>
        </div>
        ),
    },
    // Chaitanya-5838-Added column for leadInteractionDate
    {
      title: "Lead Interaction Date",
      dataIndex: "leadInteractionDate",
      key: "leadInteractionDate",
      width: "12%",
      align: "Center",
      render: (text, record) => <div>{record.leadInteractionDate}</div>,
    },
    {
        //sunita-task-3271-added below code as per requirement
        title: "Voice Log Link",
        dataIndex: "voiceLogLink",
        key: "voiceLogLink",
        width: "12%",
        align: "Center", //Sandeep-tsk-3441

        render: (text, record) => (
        <div>
            <span style={{ fontSize: "13px", color: "#1890FF" }}>
            {this.state.marketingChannelFlag === true ? (
                // Anshul-5883: commented below unnecessary code
                //sunita-task-3271-added condition as per channel for showing voicelog link column
                //kiran-4752-removing console warning-added "#/"
                 /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
                // record.channel === "Telemarketing" ||
                // record.Channel === "Telemarketing" ||
                // ((record.channel === "Email & Telemarketing" ||
                // record.Channel === "Email & Telemarketing" ||
                // record.channel === "Email" ||
                // record.Channel === "Email") &&
                // record.callAudit === "Yes") ? (
                <a
                    href="#/"
                    onClick={this.openLinkInBrowser}
                    id={record.leadInfoID}
                >
                    Link
                </a>
                // ) : (
                // <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
                //     No Link Available
                // </span>
                // )
            ) : (
                ""
            )}
            </span>
        </div>
        ),
    },
    {
        title: "Job Title",
        dataIndex: "jobTitle",
        key: "jobTitle",
        width: "17%",
        align: "Center", //Sandeep-task-3441

        render: (
        text,
        record //sunita-task-3271-added below code as per requirement
        ) => (
        <div>
            <span style={{ fontSize: "13px", color: "#4F4F4F" }} title={record.jobTitle}>
            {record.jobTitle}
            </span>
        </div>
        ),
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: "17%",
        align: "Center", //Sandeep-task-3441
        render: (text, record, i) => {
          const pageSize = this.state.pageSize2; //Nilesh-5487- Number of rows per page
          const currentPage = this.state.tableState.current || 1; //Nilesh-5487- Current page
          const absoluteIndex = (currentPage - 1) * pageSize + i; //Nilesh-5487- Calculate absolute index
      
          return (
            <div>
              <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
            {/*sunita-task-3271-added css  as per requirement*/}
                {this.state.reviewFlag === true ? (
                  <label>{text}</label>
                ) : (
                  // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
                  (() => {
                    const mc = (this.state.marketingChannel || "").toLowerCase();
                    // if (mc === "email/telemarketing" || mc === "telemarketing" || mc.includes("tele")) {
                    //   const userRole = (this.props.auth && this.props.auth.user && this.props.auth.user.role) || "";
                    //   //const isDT = userRole.toString().toUpperCase() === "DT";
                    //   const isDT = ["DT", "DIQA"].includes(userRole.toString().toUpperCase());

                    //   if (isDT || isDT ==="DIQA") {
                    //     return (
                    //       <select
                    //         style={{ height: "60%", width: "100%" }}
                    //         id="status"
                    //         name="status"
                    //         value={record.status || "TM ACCEPTED"}
                    //         onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                    //         className="form-control"
                    //       >
                    //         <option value="TM ACCEPTED">TM ACCEPTED</option>
                    //         <option value="TM REJECTED">TM REJECTED</option>
                    //       </select>
                    //     );
                    //   }
                    //   return (
                    //     <select
                    //       style={{ height: "60%", width: "100%" }}
                    //       id="status"
                    //       name="status"
                    //       value={record.status || "TM Review"}
                    //       onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                    //       className="form-control"
                    //     >
                    //       <option value="TM Review">TM Review2</option>
                    //       <option value="DI QA REJECTED">DI QA REJECTED</option>
                    //     </select>
                    //   );
                    // } else if (mc === "email") {
                    //   return (
                    //     <select
                    //       style={{ height: "60%", width: "100%" }}
                    //       id="status"
                    //       name="status"
                    //       value={record.status || "DI QA ACCEPTED"}
                    //       onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                    //       className="form-control"
                    //     >
                    //       <option value="DI QA ACCEPTED">DI QA ACCEPTED</option>
                    //       <option value="DI QA REJECTED">DI QA REJECTED</option>
                    //     </select>
                    //   );
                    // } else {
                    //   return (
                    //     <select
                    //       style={{ height: "60%", width: "100%" }}
                    //       id="status"
                    //       name="status"
                    //       value={record.status || "DI QA ACCEPTED"}
                    //       onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                    //       className="form-control"
                    //     >
                    //       <option value="DI QA ACCEPTED">DI QA ACCEPTED</option>
                    //       <option value="DI QA REJECTED">DI QA REJECTED</option>
                    //       <option value="PV Review">PV Review</option>
                    //     </select>
                    //   );
                    // }

                      /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
                      //Anshul-5876/5888:updated dropdown UI

                      if (mc === "Email & Telemarketing" || mc === "telemarketing" || mc.includes("tele")) {
                        if ((this.props.auth.user.role == 'LC') || (this.props.auth.user.role == 'LNQA' && this.state.assignedBy == 'LC')) {
                          return (
                            <select
                              style={{ height: "60%", width: "100%" }}
                              id="status"
                              name="status"
                              value={record.status || "TM VoiceLogReview"}
                              onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                              className="form-control"
                            >{/* Kiran Dhainje 5906 DC/DIQA-Lead Review-Change Instructions and Pass leads to PC-TM/PNC-TM */}
                              <option value="TM VoiceLogReview">TM VoiceLogReview</option>
                              <option value="LN QA REJECTED">LN QA REJECTED</option>
                            </select>
                          );
                        } else if ((this.props.auth.user.role == 'LT') || (this.props.auth.user.role == 'LNQA' && this.state.assignedBy == 'LT')) {
                          return (
                            <select
                              style={{ height: "60%", width: "100%" }}
                              id="status"
                              name="status"
                              value={record.status || "TM ACCEPTED"}
                              onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                              className="form-control"
                            >
                              <option value="TM ACCEPTED">TM ACCEPTED</option>
                              <option value="TM REJECTED">TM REJECTED</option>
                            </select>
                          );
                        }
                      } else if(mc == 'email'){
                        return (
                          <select
                            style={{ height: "60%", width: "100%" }}
                            id="status"
                            name="status"
                            value={record.status || "TM ACCEPTED"}
                            onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                            className="form-control"
                          >
                            <option value="LN QA ACCEPTED">LN QA ACCEPTED</option>
                            <option value="LN QA REJECTED">LN QA REJECTED</option>
                          </select>
                        );
                      }else if(mc == 'telemarketing'){
                        return (
                          <select
                            style={{ height: "60%", width: "100%" }}
                            id="status"
                            name="status"
                            value={record.status || "TM ACCEPTED"}
                            onChange={(e) => this.handleChangeQA(absoluteIndex, e)}
                            className="form-control"
                          >
                            <option value="TM ACCEPTED">TM ACCEPTED</option>
                            <option value="TM REJECTED">TM REJECTED</option>
                          </select>
                        );
                      }
                  })()
                )}
              </span>
            </div>
          )
        },
    },
    {
        title: "Reason For Rejection",
        dataIndex: "reason",
        key: "reason",
        width: "17%",
        align: "Center", //Sandeep-task-3441
        render: (text, record, i) => {
          const pageSize = this.state.pageSize2;
          const currentPage = this.state.tableState.current || 1;
          const absoluteIndex = (currentPage - 1) * pageSize + i;
          const userRole = (this.props.auth && this.props.auth.user && this.props.auth.user.role) || "";// Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
          //Kiran Dhainje 5875 Ref(5847)-DC/DIQA-Showing Assigned to User ID & Rejection Reason box disabled
          const isDTOrDIQA = ["LT", "LNQA"].includes(userRole.toString().toUpperCase());// Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
          const enabledForReason =
            record.status === "LN QA REJECTED" || (isDTOrDIQA && record.status === "TM REJECTED");// Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
          return (
          <div
            className="mywidth"
            style={{ fontSize: "13px", color: "#4F4F4F" }}
          >
            {this.state.reviewFlag === true ? (
              <label>{text}</label>
            ) : (
              <input
                type="text"
                id={`reason-${absoluteIndex}`} //Nilesh-5487- Unique ID for the input
                name="reason"
                value={record.reason || ""} //Nilesh-5487- Bind to the dataset value
                // disabled={record.status !== "LN QA REJECTED"} //Nilesh-5487- Enable only when status is "Rejected" //Rutuja LNQA task
                disabled={!enabledForReason} // Enable for DI QA REJECTED or  TM REJECTED // Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
                onChange={(e) => this.handleReasonChange(absoluteIndex, e)}
                className="form-control"
              />
            )}
            </div>
          );
        }
    },
    ];

    //sunita-task-3271- below all qaLeadDetails cloumns ,qaLeadDetails2 columns  are used for antd table
    const pvLeadDetails = [
    {
        title: "Lead ID",
        dataIndex: "leadInfoID",
        key: "leadInfoID",
        width: "8%",
        align: "Center", //Sandeep-task-3441
        render: (
        text,
        record //sunita-task-3271-added below code as per requirement
        ) => (
        <div>
            <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
            {record.leadInfoID}
            </span>
        </div>
        ),
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "17%",
        align: "Center", //Sandeep-task-3441

        render: (
        text,
        record //sunita-task-3271-added below code as per requirement
        ) => (
        <div>
            <span
            style={{
                fontSize: "13px",
                color: "#4F4F4F",
                wordBreak: "break-all",
            }}
            title={record.email}
            >
            {record.email}
            </span>
        </div>
        ),
    },
    // Chaitanya-5838-Added column for leadInteractionDate
    {
      title: "Lead Interaction Date",
      dataIndex: "leadInteractionDate",
      key: "leadInteractionDate",
      width: "12%",
      align: "Center",
      render: (text, record) => <div>{record.leadInteractionDate}</div>,
    },
    {
        title: "Job Title",
        dataIndex: "jobTitle",
        key: "jobTitle",
        width: "21%",
        align: "Center", //Sandeep-task-3441

        render: (
        text,
        record //sunita-task-3271-added below code as per requirement
        ) => (
        <div>
            <span style={{ fontSize: "13px", color: "#4F4F4F" }} title={record.jobTitle}>
            {record.jobTitle}
            </span>
        </div>
        ),
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: "21%",
        align: "left", //Sandeep-task-3441
        //Nilesh-5517- Add pagination code below
        render: (text, record, i) => {
          const pageSize = this.state.pageSize2; //Nilesh-5487- Number of rows per page
          const currentPage = this.state.tableState.current || 1; //Nilesh-5487- Current page
          const absoluteIndex = (currentPage - 1) * pageSize + i; //Nilesh-5487- Calculate absolute index
      
          return (
        <div>
            <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
            {this.state.reviewFlag === true ? (
                <label>{text}</label>
            ) : (
                  <select
                style={{ height: "60%", width: "100%" }}
                    id="status"
                    name="status"
                    value={record.status || "PV ACCEPTED"} //Nilesh-5487- Bind to the dataset value
                    onChange={(e) => this.handleChangeQA(absoluteIndex, e)} //Nilesh-4562- Pass absolute index
                    className="form-control"
                >
                    <option value="PV ACCEPTED">PV ACCEPTED</option>
                    <option value="PV REJECTED">PV REJECTED</option>
                </select>
            )}
            </span>
        </div>
        )
        }
    },
    {
        title: "Reason For Rejection", //Sandeep-task-3441
        dataIndex: "reason",
        key: "reason",
        width: "21%",
        align: "left", //Sandeep-task-3441
        //Nilesh-5517- Add pagination code below
        render: (text, record, i) => {
          const pageSize = this.state.pageSize2;
          const currentPage = this.state.tableState.current || 1;
          const absoluteIndex = (currentPage - 1) * pageSize + i;
          return (
        <div
            className="mywidth"
            style={{ fontSize: "13px", color: "#4F4F4F" }}
        >
            {this.state.reviewFlag === true ? (
            <label>{text}</label>
            ) : (
              <input
                type="text"
                id={`reason-${absoluteIndex}`} //Nilesh-5487- Unique ID for the input
                name="reason"
                value={record.reason || ""} //Nilesh-5487- Bind to the dataset value
                disabled={record.status !== "PV REJECTED"} //Nilesh-5487- Enable only when status is "Rejected"
                onChange={(e) => this.handleReasonChange(absoluteIndex, e)}
                className="form-control"
              />
            )}
        </div>
        );
        }
    },
    ];

    //sunita-task-3271- below all qaLeadDetails2 are used for antd table columns same as above only added one extra column for voicelog link
    const pvLeadDetails2 = [
    {
        title: "Lead ID",
        dataIndex: "leadInfoID",
        key: "leadInfoID",
        width: "8%",
        align: "Center", //Sandeep-task-3441
        render: (
        text,
        record //sunita-task-3271-added below code as per requirement
        ) => (
        <div>
            <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
            {record.leadInfoID}
            </span>
        </div>
        ),
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "17%",
        align: "Center", //Sandeep-task-3441

        render: (
        text,
        record //sunita-task-3271-added below code as per requirement
        ) => (
        <div>
            {/* <span style={{ fontSize: '11px',wordBreak: "break-all" }}> */}
            <span
            style={{
                fontSize: "13px",
                color: "#4F4F4F",
                wordBreak: "break-all",
            }}
            title={record.email}
            >
            {record.email}
            </span>
        </div>
        ),
    },
    // Chaitanya-5838-Added column for leadInteractionDate
    {
      title: "Lead Interaction Date",
      dataIndex: "leadInteractionDate",
      key: "leadInteractionDate",
      width: "12%",
      align: "Center",
      render: (text, record) => <div>{record.leadInteractionDate}</div>,
    },
    {
        //sunita-task-3271-added below code as per requirement
        title: "Voice Log Link",
        dataIndex: "voiceLogLink",
        key: "voiceLogLink",
        width: "12%",
        align: "Center", //Sandeep-tsk-3441

        render: (text, record) => (
        <div>
            <span style={{ fontSize: "13px", color: "#1890FF" }}>
            {this.state.marketingChannelFlag === true ? (
                // Anshul-5883: commented below unncessary code
                //sunita-task-3271-added condition as per channel for showing voicelog link column
                //kiran-4752-removing console warning-added "#/"
                /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/
                // record.channel === "Telemarketing" ||
                //   record.Channel === "Telemarketing" ||
                //   ((record.channel === "Email & Telemarketing" ||
                //     record.Channel === "Email & Telemarketing" ||
                //     record.channel === "Email" ||
                //     record.Channel === "Email") &&
                //     record.callAudit === "Yes") ? (
                <a
                    href="#/"
                    onClick={this.openLinkInBrowser}
                    id={record.leadInfoID}
                >
                    Link
                </a>
                // ) : (
                // <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
                //     No Link Available
                // </span>
                // )
            ) : (
                ""
            )}
            </span>
        </div>
        ),
    },
    {
        title: "Job Title",
        dataIndex: "jobTitle",
        key: "jobTitle",
        width: "17%",
        align: "Center", //Sandeep-task-3441

        render: (
        text,
        record //sunita-task-3271-added below code as per requirement
        ) => (
        <div>
            <span style={{ fontSize: "13px", color: "#4F4F4F" }} title={record.jobTitle}>
            {record.jobTitle}
            </span>
        </div>
        ),
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: "17%",
        align: "Center", //Sandeep-task-3441
        //Nilesh-5517- Add pagination code below
        render: (text, record, i) => {
          const pageSize = this.state.pageSize2; //Nilesh-5487- Number of rows per page
          const currentPage = this.state.tableState.current || 1; //Nilesh-5487- Current page
          const absoluteIndex = (currentPage - 1) * pageSize + i; //Nilesh-5487- Calculate absolute index
      
          return (
        <div>
            <span style={{ fontSize: "13px", color: "#4F4F4F" }}>
            {/*sunita-task-3271-added css  as per requirement*/}
            {this.state.reviewFlag === true ? (
                <label>{text}</label>
            ) : (
                  <select
                style={{ height: "60%", width: "100%" }}
                    id="status"
                    name="status"
                    value={record.status || "PV ACCEPTED"} //Nilesh-5487- Bind to the dataset value
                    onChange={(e) => this.handleChangeQA(absoluteIndex, e)} //Nilesh-4562- Pass absolute index
                    className="form-control"
                >
                    <option value="PV ACCEPTED">PV ACCEPTED</option>
                    <option value="PV REJECTED">PV REJECTED</option>
                  </select>
            )}
            </span>
        </div>
        )
        },
    },
    {
        title: "Reason For Rejection",
        dataIndex: "reason",
        key: "reason",
        width: "17%",
        align: "Center", //Sandeep-task-3441
        //Nilesh-5517- Add pagination code below
        render: (text, record, i) => {
          const pageSize = this.state.pageSize2;
          const currentPage = this.state.tableState.current || 1;
          const absoluteIndex = (currentPage - 1) * pageSize + i;
          return (
        <div
            className="mywidth"
            style={{ fontSize: "13px", color: "#4F4F4F" }}
        >
            {this.state.reviewFlag === true ? (
            <label>{text}</label>
            ) : (
              <input
                type="text"
                id={`reason-${absoluteIndex}`} //Nilesh-5487- Unique ID for the input
                name="reason"
                value={record.reason || ""} //Nilesh-5487- Bind to the dataset value
                disabled={record.status !== "PV REJECTED"} //Nilesh-5487- Enable only when status is "Rejected"
                onChange={(e) => this.handleReasonChange(absoluteIndex, e)}
                className="form-control"
            />
            )}
        </div>
          );
        }
    },
    ];

    //sunita-task-3271-added below code as per requirement
    // removed unused onChange function to resolve lint warning
    // const asterisk =
    // {
    //   color: 'red',
    //   fontWeight: "500"
    // }
    // const cardBody = {
    //   height: "350px"
    // } //kiran-4752-removing console warning-no used
  

    return (
        <div>
          <LeadReviewLoader
            loadingRef={this.loadingRef}
            closeLoadingRef={this.closeLoadingRef}
            message="Please wait. Saving the data...."
          />{" "}
          {/* Sandeep-task-3341-added code for loader */}
          <Navigation />
          {/* Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel */}
          <style>{`.nav-tabs .nav-link.pv-disabled-tab{background:#e0e0e0 !important;color:#9e9e9e !important;border-color:#d0d0d0 !important;box-shadow:none !important;pointer-events:none;} .nav-tabs .nav-link.pv-disabled-tab:hover{background:#e0e0e0 !important;}`}</style>
          {/* Priyanka-4603-Added code to add PV tab*/}
          <div
            class="container-fluid"
            id="tabsContainer"
            style={{ paddingTop: "85px" }}
          >
            <Tabs activeKey={this.state.key} onSelect={this.handleSelect}>
              {/* //Rutuja LNQA task */}
              <Tab eventKey={1} title="LN QA Review"> 
                <div class="container-fluid " style={{ fontFamily: "roboto" }}>
                  <div class="row" style={{ paddingTop: "10px" }}>
                    {/*sunita-task-3271-added code as per requirement */}
                    {/* Rutuja Jagtap task-3879 added Campaign Specification button for DIQA role */}
  
                    <div class="col-xs-12 col-sm-12  col-lg-4 col-xl-4">
                      {/*Priyanka-5465-Changed page name to redirection*/}
                      {this.props.auth.user.role === "LC" ?
                      (<a
                        class="TabOne"
                        href={"/qualityDashboard"}
                        style={{ color: "#056eb8" }}
                        >
                        <FaArrowAltCircleLeft
                            size={50}
                            style={{ float: "left", paddingTop: "20px" }}
                            title="Back to Dashboard"
                        />
                        </a>)
                      :("")
                      }
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <center>
                        <label id="labelDI">LN Quality Analyst</label>
                      </center>
                      {/* sunita-task-3271- added  code as per new screen requirement */}
                    </div>
                   <div
                    class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
                    style={{ textAlign: "right", marginTop: "6px" }}
                  >

                    {/* Kiran Dhainje 5958 added Internal Notes Icon - moved to LEFT */}
                     {/* Kiran Dhainje 6001 Changed Internal Notes */}
                    <span
                      className="internal-notes-icon-wrapper"
                      style={{ display: "inline-block", marginRight: "10px", verticalAlign: "middle" }}
                    >
                      <Badge
                        count={otherNotesCount > 10 ? "10+" : otherNotesCount}
                        overflowCount={10}
                        offset={[1, -5]}
                      >
                        <img
                          src="/notes.png"
                          alt="Campaign Internal Notes"
                          onClick={this.openNotesModal}
                          className="internal-notes-trigger internal-notes-icon"
                          title="View Internal Campaign Notes"
                          style={{ width: "27px", height: "27px", cursor: "pointer" }}
                        />
                      </Badge>
                    </span>

                    {/* Campaign Specification Button */}
                    <button
                      class="btn add-button"
                      onClick={this.displayCampaignSpecification}
                      disabled={this.state.leadDetails.length === 0 && this.state.key === 1}
                      style={{ marginRight: "10px" }}
                    >
                      Campaign Specification
                    </button>

                    {/* Alerts Button */}
                    <Badge
                      count={this.state.unreadAlerts.length <= 10 ? this.state.unreadAlerts.length : "10+"}
                      overflowCount={10}
                      offset={[1, -5]}
                    >
                      <button
                        class="btn add-button"
                        onClick={this.unreadAlerts.bind(this)}
                        style={{ marginRight: "10px" }}
                      >
                        Alerts
                      </button>
                    </Badge>
                    </div>
                  </div>
  
                  {/* <div class="row"> */}
                  {/* sunita-task-3271- added below code as per new screen requirement */}
                    {/* Anshul-5960: added new class to add scroll for right section and fixed the height */}
                <div class="card card-signin my-1 dc-card-backgound">
                    <div class="card-body" style={{ padding: "5px" }}>
                      {/* <div class="col-sm-12 col-md-4 col-lg-3"> */}
                      <div
                        class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 qacampaignDetailsDiv "
                        style={{
                          background: "#FFFFFF",
                          borderRight: "2px solid #eee",
                          padding: "0px",
                          height: "auto",
                        }}
                      >
                        {" "}
                        {/*sunita-task-3271-added code as per requirement */}
                        {/* <div><h4>Campaign List</h4> <hr style={{ marginBottom: "0px" }} /></div> */}
                        <div>
                          <center>
                            <label
                              className="campLeadHeading"
                              style={{
                                fontSize: "17px",
                                color: "#14254A",
                                marginTop: "10px",
                                fontWeight: "500",
                                fontFamily: "roboto",
                              }}
                            >
                              Campaigns for Lead Review :
                            </label>
                          </center>
                        </div>
                        {/* sunita-task-3271-added below code for  search */}
                        <div class="row">
                          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                            <span>
                              <input
                                className="inputstyle4"
                                name="search"
                                placeholder="Search Campaign"
                                style={{
                                  backgroundImage: "url(searchIcon.png)",
                                  backgroundPosition: "15px 6px",
                                  backgroundSize: "15px 15px",
                                  backgroundRepeat: "no-repeat",
                                  width: "280px",
                                  height: "28px",
                                  fontSize: "12px",
                                  // float: 'left',
                                  // marginLeft: '17px',
                                  border: "1px solid #CCCCCC",
                                  padding: "12px 20px 15px 36px",
                                  backgroundColor: "#FFFFFF",
                                  // marginBottom: '5px',
                                  // borderBottom: '1px solid #eee',
                                  fontFamily: "sans-serif",
                                  borderRadius: "2px",
                                }}
                                onChange={this.handleChangeSearch}
                                onPressEnter={this.handleChangeSearch}
                              ></input>
                            </span>
                          </div>
                        </div>
                        <br />
                        <hr />
                        {/* sunita-task-3271-added below condition as search table data */}
                        <div
                          style={{
                            overflowY: "scroll",
                            height: "auto",
                            background: "#FFFFFF",
                            padding: "0px",
                            borderRight: "2px solid #eee",
                            marginTop: "-9px",
                          }}
                            className="dc-leadReview-campList"                      
                        >
                          {" "}
                          {/*sunita-task-3271-added col and it's data as per requirement */}
                          {this.state.tableSearchText === "" ? (
                            <div>
                              {this.state.campList.map((campList) => (
                                <div
                                  style={{
                                    borderBottom: "1px solid #eee",
                                    padding: "5px 15px",
                                  }}
                                  className="campNames"
                                >
                                  {/* 4610-Nilesh Add agency camp ID i.e clientCampID */}
                                  {/* kiran-4752-removing console warning-added "#/" */}
                                  <a
                                    href="#/"
                                    className="reviewcampdata"
                                    id={campList.campID}
                                    onClick={this.displayLeads}
                                  >
                                    {campList.campID} - {campList.clientCampID} -{" "}
                                    {campList.campaignName}{" "}
                                  </a>
                                </div>
                              ))}
                            </div>
                          ) : this.state.campListSearch.length > 0 ? (
                            <div>
                              {this.state.campListSearch.map((campListSearch) => (
                                <div
                                  style={{
                                    borderBottom: "1px solid #eee",
                                    padding: "5px 15px",
                                  }}
                                  className="campNames"
                                >
                                  {/* 4610-Nilesh Add agency camp ID i.e clientCampID */}
                                  <a
                                    href="#/"
                                    className="reviewcampdata"
                                    id={campListSearch.campID}
                                    onClick={this.displayLeads}
                                  >
                                    {campListSearch.campID} -{" "}
                                    {campListSearch.clientCampID} -{" "}
                                    {campListSearch.campaignName}{" "}
                                  </a>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <center>
                              <label
                                style={{
                                  color: "red",
                                  fontSize: "medium",
                                  marginTop: "34px",
                                }}
                              >
                                No Data Exist
                              </label>
                            </center>
                          )}
                        </div>
                      </div>
  
                      {/* <br /> */}
                      {/* <div id="class one Div" class="col-sm-12 col-md-8 col-lg-9">
                <div class="card" >
                  <div className="card-body card-body2"> 
                    {/* <div> */}
                      {/*sunita-task-3271-added below code as per requirement  */}
                      {/* Rutuja Jagtap task-3879 Responsive*/}
                      <div
                        className="col-xs-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 qacampaignDetails"
                        style={{ background: "#FFFFFF", paddingTop: "20px" }}
                      >
                        {/*sunita-task-3271-added code as per requirement */}
                        <div
                          id="pleaseWait"
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            fontSize: "13px",
                            left: "400px",
                            top: "200px",
                          }}
                          className={this.state.loading}
                        ></div>
                        <div>
                        {/* //Rutuja task 5634 disabled upload lead when there is no data */}
                          {this.state.leadDetails.length > 0 && this.state.key === 1 && (
                            this.state.campDetails.map((details) => {
                            return (
                              <div>
                                {/* Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel added below css to disable the pv Review Tab */}
                                <style>{`
                                .disable-tab {
                                  pointer-events: none !important;
                                  cursor: default !important;
                                  opacity: 1 !important;
                                }
                              `}</style>  
                                {/*sunita-task-3271-added below label css changes for campID,campname,start date,end date and type as per new requirement for alignment*/}
                                <div
                                  className="row"
                                  style={{ marginTop: "-9px" }}
                                >
                                  {/* <div className="col-sm-12 col-md-6 col-lg-8"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Campaign ID :
                                    </label>{" "}
                                    &nbsp;<span>{details.campID}</span>
                                  </div>
                                  {/* </div> */}
                                  {/* <div className="row"> */}
                                  {/* <div className="col-sm-12 col-md-8 col-lg-8"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-8">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Campaign Name :{" "}
                                    </label>
                                    &nbsp;
                                   <span className="reviewcampdata1">
                                      {" "}
                                      {/* {details.campaignName} */}
                                      {/* Anshul-5960: commented above line and added below to show full campaign name in the tooltip */}
                                      <Tooltip placement="bottomRight" title={details.campaignName}>
                                        <span>{truncateText(details.campaignName, 16)}</span>
                                      </Tooltip>
                                    </span>
                                  </div>
                                  {/* </div> */}
  
                                  {/* <div className="row"> */}
                                  {/* <div className="col-sm-12 col-md-6 col-lg-3"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Campaign Type :
                                    </label>
                                    &nbsp;<span> {details.ABM}</span>
                                  </div>
  
                                  {/* <div className="col-sm-12 col-md-6 col-lg-3"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Start Date :
                                    </label>
                                    &nbsp;<span> {details.startDate}</span>
                                  </div>
  
                                  {/* <div className="col-sm-12 col-md-6 col-lg-3"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      End Date :
                                    </label>
                                    &nbsp;<span>{details.endDate}</span>
                                  </div>
                                  {/* Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel*/}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Marketing Channel :
                                    </label>
                                    &nbsp;<span>{details.marketingChannel}</span>
                                  </div>
                                </div>
                              </div>
                            );
                          }))}
                        </div>
  
                        <br />
  
                        <hr />
  
                        {/* Anshul-5960: added loader at correct position (at center) */}
                      <div id={this.state.loader2}></div>
                      {/* Anshul-5960: added below to new classes to fixed the hight of right section and added scrolling if max height exceed */}
                      <div className="dc-leadReview-leadDetails">
                        <div className="dc-leadReview-content">
                        <div className="row" style={{ marginLeft: "0px" }}>
                          <div>
                            {/*sunita-task-3271-added below changes as per new requirement screen for instructions*/}
                            <h5>
                              <span
                                style={{ fontWeight: "bold", color: "#F28C0F" }}
                              >
                                Offline Lead Review Instructions :-{" "}
                              </span>
                              <br />
                            </h5>
                            <span>
                              1. Click on <b>"Download Leads" </b> to get Lead's
                              File.
                            </span>
                            <br />
                              {/* //Rutuja LNQA task */}
                               {/* Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel*/}
                            <span>
                              2. After reviewing the lead, Please update status as{" "}
                              <b>
                                {(() => {
                                  const mc = (this.state.marketingChannel || "").toLowerCase();
                                  const userRole = (this.props.auth && this.props.auth.user && this.props.auth.user.role) || "";
                                  //const isDT = userRole.toString().toUpperCase() === "DT";
                                  const isDT = ["LT", "LNQA"].includes(userRole.toString().toUpperCase());

                                /* Chaitanya-5868-Changed Email/Telemarketing to Email & Telemarketing*/

                                if (mc === "Email & Telemarketing" || mc === "telemarketing" || mc.includes("tele")) {
                                  
                                    if ((this.props.auth.user.role == 'LC') || (this.props.auth.user.role == 'LNQA' && this.state.assignedBy == 'LC')) {
                                        return '"TM VoiceLogReview" OR "LN QA REJECTED" ';//Kiran Dhainje 5906 DC/DIQA-Lead Review-Change Instructions
                                    } else if ((this.props.auth.user.role == 'LT') || (this.props.auth.user.role == 'LNQA' && this.state.assignedBy == 'LT')) {
                                      return '"TM ACCEPTED" OR "TM REJECTED" ';
                                    }
                                  } else if (mc === "email") {
                                    return '"LN QA ACCEPTED" OR "LN QA REJECTED"';
                                  }else if(mc == 'telemarketing'){
                                    return '"TM ACCEPTED" OR "TM REJECTED" ';
                                  }else{
                                    if ((this.props.auth.user.role == 'LC') || (this.props.auth.user.role == 'LNQA' && this.state.assignedBy == 'LC')){
                                      return '"LN QA ACCEPTED" OR "LN QA REJECTED"';
                                    } else if ((this.props.auth.user.role == 'LT') || (this.props.auth.user.role == 'LNQA' && this.state.assignedBy == 'LT')){
                                      return '"TM Review" OR "LN QA REJECTED" ';
                                    }
                                  }
                                 
                                })()}
                              </b>
                              in Status column in Lead's File.
                            </span>
                          </div>
                          <div>
                            <span>
                              3. If you rejecting the lead then please{" "}
                              <b> add reason of rejection </b> in reason column in
                              Lead's File.
                            </span>
                            <br />
                            <span>
                              4. Click on <b>"Upload Lead"</b> to upload reviewed
                              Lead's File.
                            </span>
                          </div>
                        </div>
                        <br />
  
                        {/* Aman-4947-added below all row inside code to display inpute filed to filter lead as per the dates */}
                        <div className="row">
                          <div
                            className="col-xs-5 col-sm-5 col-md-7 col-lg-7 col-xl-5"
                            id="dateForm"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                              gap: "3",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flexWrap: "wrap",
                              }}
                            >
                              <label
                                style={{
                                  fontSize: "14px",
                                  color: "#14254A",
                                  fontFamily: "sans-serif",
                                  marginRight: "10px",
                                }}
                              >
                                Lead Start Date&nbsp;&nbsp;
                                <HtmlTooltip
                                  placement="right"
                                  title={
                                    <React.Fragment>
                                      <ol>
                                        <li>
                                          {/* 4433-validation changes */}
                                          {
                                            'Selected date range will list the lead data on  "Leads Created Date" only.'
                                          }
                                        </li>
                                        <li>
                                          {
                                            "Start Date and End Date both need to select to filter the lead data."
                                          }
                                        </li>
                                      </ol>
                                    </React.Fragment>
                                  }
                                >
                                  <Icon type="question-circle" />
                                </HtmlTooltip>
                              </label>
  
                              <input
                                type="date"
                                id="startDate"
                                name="startDate"
                                min=""
                                pattern="[0-9]{2}-[0-9]{2}-[0-9]{4}"
                                value={this.state.selectedDateStart}
                                onChange={this.startDatedateHandleChange}
                                className="form-control"
                                required
                              />
                            </div>
  
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flexWrap: "wrap",
                              }}
                            >
                              <label
                                style={{
                                  fontSize: "14px",
                                  color: "#14254A",
                                  fontFamily: "sans-serif",
                                  marginRight: "10px",
                                }}
                              >
                                Lead End Date&nbsp;&nbsp;
                                <HtmlTooltip
                                  placement="right"
                                  title={
                                    <React.Fragment>
                                      <ol>
                                        <li>
                                          {/* 4433-validation changes */}
                                          {
                                            'Selected date range will list the lead data on  "Leads Created Date" only.'
                                          }
                                        </li>
                                        <li>
                                          {
                                            "Start Date and End Date both need to select to filter the lead data."
                                          }
                                        </li>
                                      </ol>
                                    </React.Fragment>
                                  }
                                >
                                  <Icon type="question-circle" />
                                </HtmlTooltip>
                              </label>
  
                              <input
                                type="date"
                                id="endDate"
                                name="endDate"
                                min=""
                                pattern="[0-9]{2}-[0-9]{2}-[0-9]{4}"
                                value={this.state.selectedDateEnd}
                                onChange={this.endDatedateHandleChange}
                                className="form-control"
                                required
                              />
                            </div>
  
                            {/* {this.state.selectedDateStart === "" ? ("") : (<p style={{color: "red"}}>please select End Date to also to get lead count as per the Date</p>)} */}
                          </div>
                        </div>
                        <br />
  
                        <div className="row">
                          <div className="col-sm-12 col-md-6 col-lg-6">
                            {/*sunita-task-3160-added column for proper alignment*/}
                            <button
                              class="btn add-button"
                              type="button"
                              onClick={this.downloadFile}
                              style={{
                                backgroundColor: "#056eb8",
                                color: "white",
                                height: "32px",
                                fontSize: "14px",
                                fontFamily: "sans-serif",
                                fontWeight: "400",
                                borderRadius: "4px",
                              }}
                              disabled={
                                this.state.leadDetails.length > 0 ? false : true
                              }
                            >
                              {/*sunita-task-3271-added  css as per requirement */}
                              <i
                                class="fa fa-cloud-download"
                                aria-hidden="true"
                              ></i>
                              &nbsp;Download Leads
                            </button>
                          </div>
                          <div className="col-sm-12 col-md-6 col-lg-6">
                            <span className="mobileCss">
                              Download Leads:{" "}
                              {this.state.getLeadCounts > 0
                                ? this.state.getLeadCounts
                                : 0}{" "}
                              &nbsp; | &nbsp; New Leads :{" "}
                              {this.state.leadDetailsCount -
                                this.state.getLeadCounts}
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-sm-12 col-md-6 col-lg-6"
                            id="lead_button1"
                          >
                            {/*sunita-task-3160-added column as per requirement */}
                            {/*sunita-task-3271-added css as per requirement */}
                            <label
                              class=" btn btn-defaulttab"
                              style={{
                                cursor:
                                  this.state.leadDetails.length > 0
                                    ? "default"
                                    : "no-drop",
                                height: "32px",
                                fontFamily: "sans-serif",
                                fontSize: "14px",
                                fontWeight: "400",
                                borderRadius: "4px",
                                backgroundColor: "transparent",
                                color: "#193D8F",
                                border: "1px solid #193D8F",
                              }}
                              disabled={
                                this.state.leadDetails.length > 0 ? false : true
                              }
                            >
                              Upload Lead
                              <input
                                disabled={
                                  this.state.leadDetails.length > 0 ? false : true
                                }
                                id="abm1"
                                key={this.state.filesData1}
                                style={{ display: "none" }}
                                type="file"
                                onChange={this.fileupload}
                              />{" "}
                              {/*-sunita-task-3271-added for file*/}
                            </label>
                            <span
                              id="fileName1"
                              style={{
                                width: "150px",
                                textOverflow: "ellipsis",
                                display: "contents",
                                cursor:
                                  this.state.leadDetails.length > 0
                                    ? "default"
                                    : "no-drop",
                              }}
                              disabled={
                                this.state.leadDetails.length > 0 ? false : true
                              }
                            >
                              No File Choosen
                            </span>
                            {/*sunita-task-3271-added as per requirement */}
                          </div>
                        </div>
  
                        <br />
                        <div
                          class="row"
                          style={{
                            marginBottom: "6px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          {/*sunita-task-3160-added row and column as per requirement */}
                          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
                            <span
                              style={{
                                fontWeight: "bold",
                                marginTop: "115px",
                                color: "#056eb8",
                              }}
                            >
                              Online Lead Review & Instant Status Update :-
                              <br />
                            </span>
                            {/*Aman-4947-added condition of filterleadDetailsCount to display filter lead count with date*/}
                             <span style={{ display: "flex" }}>
                              Total Leads :{" "}
                              {this.state.filterleadDetailsSatus === true ? (
                                <div>
                                  &nbsp;
                                  <b>{this.state.filterleadDetailsCount}</b>
                                    &nbsp;
                                    {/* Nilesh-5890-added below condition for undefined data */}
                                    {this.state.stectedStartDateforDisplay &&
                                      this.state.stectedEndDateforDisplay && (
                                        <>
                                          from{" "}
                                          <b>
                                            {this.state.stectedStartDateforDisplay}
                                          </b>{" "}
                                          to{" "}
                                          <b>
                                            {this.state.stectedEndDateforDisplay}
                                          </b>
                                        </>
                                      )}
                                  </div>
                                ) : (
                                  <b>&nbsp;{this.state.leadDetails.length}</b>
                                )}
                            </span>
                          </div>
  
                       <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 btn_Submit">
  {/* Submit Top */}
   {/* 5775 Kiran Dhainje Prod Issue-DC/DIQA-Lead Review-Error Message and Button Enablement Issue*/}
  <button
    className="btn add-button"
    id="submitButtonTop"   
    onClick={this.handleSubmit}
    disabled={this.state.leadDetails.length === 0 || this.state.isFileUploadCompleted   }
    style={{
      align: "right",
      paddingBottom: "6px",
      fontFamily: "sans-serif",
      fontSize: "14px",
      fontWeight: "400",
      borderRadius: "4px",
    }}
  >
    Submit
  </button>
</div>

{/* Reject All Top */}{/* 5775 Kiran Dhainje Prod Issue-DC/DIQA-Lead Review-Error Message and Button Enablement Issue*/}

<div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 btn_Submit">
  <button
    className="btn add-button"
    id="rejectAllButtonTop"
    onClick={this.handleDelete}
    disabled={this.state.leadDetails.length === 0 || this.state.isFileUploadCompleted}
    style={{
      align: "right",
      paddingBottom: "6px",
      fontFamily: "sans-serif",
      fontSize: "14px",
      fontWeight: "400",
      borderRadius: "4px",
    }}
  >
    Reject All
  </button>
</div>
                           {/* rutuja 5463 showing error when manually rejecting leads and not entered reason */}
                            {this.state.reasonErrorDisplayFlag1 === true ? (
                              <span style={{ color: "red", marginLeft: "2%" }}>
                                Please enter reason for Rejection
                              </span>
                            ) : (
                              ""
                            )}
                        </div>
  
                        {/*sunita-task-3271-added some attributes as per requirement in table */}
                        {/* Sandeep-task-3441-added loader */}
                        {/* Anshul-5960: moved this loader to centre of the page */}
                        {/* <div id={this.state.loader2}></div> */}
                        <Table
                          {...this.state.tableState}
                          columns={
                            this.state.marketingChannelFlag === true
                              ? qaLeadDetails2
                              : qaLeadDetails
                          }
                          rowClassName={"qaLeadDetails"}
                          onChange={this.onTableChange} //Nilesh-5487- call onTableChange function
                          class="ant-table-thead"
                          className={tableCSS}
                          dataSource={
                            this.state.filterleadDetailsSatus === true
                              ? this.state.filterleadDetails
                              : this.state.leadDetails
                          } //Aman-4947-added filterleadDetailsSatus to display filter lead or total lead in the table
                          //4562 -(as discussed with ram sir, commented the pagination for this_issue) Prod_Issue - AC, AQA, ANC, DIQA, Publisher, PQA, Advertiser -Leads Review-Leads Rejected Issue
                          //pagination={false}
                          //Priyanka-Because of unresponsive popup reverting task 4562
                          pagination={{
                            pageSize: this.state.pageSize2,
                            position: "bottom",
                          }}
                          loading={this.state.loading1}
                          scroll={{ x: 1300, y: 450 }} //Nilesh-5517- Change y axis scrolling
                          bordered={true}
                        >
                          {" "}
                          {/* y:1333 - 4562 -change the table height */}
                          {/*className={tableCSS + " " + 'myFont'} >{/*sunita-task-3180-removed css as not needed*/}
                        </Table>
                        {/* <p> */}
                        {/* 4562 -(as discussed with ram sir, commented the pagination for this_issue) Prod_Issue - AC, AQA, ANC, DIQA, Publisher, PQA, Advertiser -Leads Review-Leads Rejected Issue */}
                        {/* sunita-task-3271-added below code for paginaion */}
                        {/* Priyanka-Because of unresponsive popup reverting task 4562 */}
                        <div class="row">
                          <div
                            class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                            style={{
                              marginTop: "-52px",
                              marginLeft: "5px",
                              fontSize: "13px",
                              color: "#4F4F4F",
                              fontFamily: "sans-serif",
                            }}
                          >
                            &nbsp;&nbsp;&nbsp;Records per page:&nbsp;
                            <select
                              value={this.state.pageSize2}
                              onChange={this.handleChangePageSize2}
                              id="pacing1"
                              class="input-small"
                              className="form-control"
                              name="pacing"
                              style={{
                                width: "71px",
                                height: "30px",
                                display: "initial",
                                fontSize: "13px",
                                fontFamily: "sans-serif",
                                color: "#4F4F4F",
                              }}
                            >
                              {/* sunita-task-3271-added css as per requirement  */}
                              <option value="100" selected>
                                100
                              </option>
                              <option value="200">200</option>
                              <option value="300">300</option>
                            </select>
                          </div>
                        </div>
                        {/* </p> */}
  
                        <br />
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-8"
                            style={{ textAlign: "left" }}
                          ></div>
                          <div
  className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 btn_Submit"
  style={{ marginBottom: "40px" }}
>
{/* 5775 Kiran Dhainje Prod Issue-DC/DIQA-Lead Review-Error Message and Button Enablement Issue*/}

  <button
    className="btn add-button"
    id="submitButtonBottom"
    onClick={this.handleSubmit}
    disabled={this.state.leadDetails.length === 0 || this.state.isFileUploadCompleted}
    style={{
      align: "right",
      paddingBottom: "6px",
      fontFamily: "sans-serif",
      fontSize: "14px",
      fontWeight: "400",
      borderRadius: "4px",
    }}
  >
    Submit
  </button>
</div>

{/* Reject All Bottom */}
{/* 5775 Kiran Dhainje Prod Issue-DC/DIQA-Lead Review-Error Message and Button Enablement Issue*/}

<div
  className="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-2 btn_Submit"
  style={{ marginBottom: "40px" }}
>
  <button
    className="btn add-button"
    id="rejectAllButtonBottom"
    onClick={this.handleDelete}
    disabled={this.state.leadDetails.length === 0 || this.state.isFileUploadCompleted}
    style={{
      align: "right",
      paddingBottom: "6px",
      fontFamily: "sans-serif",
      fontSize: "14px",
      fontWeight: "400",
      borderRadius: "4px",
    }}
  >
    Reject All
  </button>
</div>
                        </div>
                      </div>
                      {/* </div>{/*3rd */}
                      {/* </div>2nd */}
                      {/* </div> 1st */}
                      {/* </div> */}
                    </div>
                  </div>
                </div>
                 </div>
              </div>
              </Tab>
              {/* Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel */}
              <Tab eventKey={2} title="PV Review" tabClassName="disable-tab" cursor="not-allowed">
                <div class="container-fluid " style={{ fontFamily: "roboto" }}>
                  <div class="row" style={{ paddingTop: "10px" }}>
                    {/*sunita-task-3271-added code as per requirement */}
                    {/* Rutuja Jagtap task-3879 added Campaign Specification button for DIQA role */}
  
                    <div class="col-xs-12 col-sm-12  col-lg-4 col-xl-4">
                      {/*Priyanka-5465-Added back button to redirect to dashboard*/}
                      {this.props.auth.user.role === "LC" ?
                      (<a
                        class="TabOne"
                        href={"/qualityDashboard"}
                        style={{ color: "#056eb8" }}
                        >
                        <FaArrowAltCircleLeft
                            size={50}
                            style={{ float: "left", paddingTop: "20px" }}
                            title="Back to Dashboard"
                        />
                        </a>)
                      :("")
                      }
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                      <center>
                        <label id="labelDI">PV Review</label>
                      </center>
                      {/* sunita-task-3271- added  code as per new screen requirement */}
                    </div>
                    <div
                      class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
                      style={{ textAlign: "center", marginTop: "6px" }}
                    >
                      {/* //Rutuja task 5634 disabled camp spec when there is no data */}
                       {/* //Kiran Dhainje 5958 Added below code */}
                      <div
                        className="internal-notes-icon-wrapper"
                        style={{ display: "inline-block", marginRight: "10px", verticalAlign: "middle" }}
                      >
                        <img
                          src="/notes.png"
                          alt="Campaign Internal Notes"
                          onClick={this.openNotesModal}
                          className="internal-notes-trigger internal-notes-icon"
                          title="Add Internal Campaign Notes"
                          style={{ width: "24px", height: "24px", cursor: "pointer" }}
                        />
                        {otherNotesCount > 0 && (
                          <span className="internal-notes-badge">
                            {otherNotesCount > 10 ? "10+" : otherNotesCount}
                          </span>
                        )}
                      </div>
                      <button
                        class="btn add-button"
                        onClick={this.displayCampaignSpecification}
                        disabled={this.state.leadDetails.length === 0 && this.state.key === 2}
                      >
                        {" "}
                        Campaign Specification
                      </button>
                      &nbsp;
                      {/* Nilesh-5055- Add alert button*/}
                      {/* <span class="badgelink"> */}
                                          <Badge
                                              count={this.state.unreadAlerts.length <= 10 ? this.state.unreadAlerts.length : "10+"}
                                              overflowCount={10}
                                              offset={[1, -5]}>
                                               <button
                        class="btn add-button"
                        onClick={this.unreadAlerts.bind(this)}
                        style={{marginLeft: "15px"}}
                      >
                        {" "}
                        Alerts
                      </button>
                                          </Badge>{" "}
                                      {/* </span> */}
                    </div>
                  </div>
  
                  {/* <div class="row"> */}
                  {/* sunita-task-3271- added below code as per new screen requirement */}
                   {/* Anshul-5960: added below dc-card-backgroud class to fixed the height of right section */}
                <div class="card card-signin my-1 dc-card-backgound">
                    <div class="card-body" style={{ padding: "5px" }}>
                      {/* <div class="col-sm-12 col-md-4 col-lg-3"> */}
                      <div
                        class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 qacampaignDetailsDiv "
                        style={{
                          background: "#FFFFFF",
                          borderRight: "2px solid #eee",
                          padding: "0px",
                          height: "auto",
                        }}
                      >
                        {" "}
                        {/*sunita-task-3271-added code as per requirement */}
                        {/* <div><h4>Campaign List</h4> <hr style={{ marginBottom: "0px" }} /></div> */}
                        <div>
                          <center>
                            <label
                              className="campLeadHeading"
                              style={{
                                fontSize: "17px",
                                color: "#14254A",
                                marginTop: "10px",
                                fontWeight: "500",
                                fontFamily: "roboto",
                              }}
                            >
                              Campaigns for Lead Review :
                            </label>
                          </center>
                        </div>
                        {/* sunita-task-3271-added below code for  search */}
                        <div class="row">
                          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                            <span>
                              <input
                                type="text"
                                className="inputstyle4"
                                name="search"
                                placeholder="Search Campaign"
                                style={{
                                  backgroundImage: "url(searchIcon.png)",
                                  backgroundPosition: "15px 6px",
                                  backgroundSize: "15px 15px",
                                  backgroundRepeat: "no-repeat",
                                  width: "280px",
                                  height: "28px",
                                  fontSize: "12px",
                                  // float: 'left',
                                  // marginLeft: '17px',
                                  border: "1px solid #CCCCCC",
                                  padding: "12px 20px 15px 36px",
                                  backgroundColor: "#FFFFFF",
                                  // marginBottom: '5px',
                                  // borderBottom: '1px solid #eee',
                                  fontFamily: "sans-serif",
                                  borderRadius: "2px",
                                }}
                                onChange={this.handleChangeSearch}
                                onPressEnter={this.handleChangeSearch}
                              ></input>
                            </span>
                          </div>
                        </div>
                        <br />
                        <hr />
                        {/* sunita-task-3271-added below condition as search table data */}
                        <div
                          style={{
                            overflowY: "scroll",
                            height: "auto",
                            background: "#FFFFFF",
                            padding: "0px",
                            borderRight: "2px solid #eee",
                            marginTop: "-9px",
                          }}
                           className="dc-leadReview-campList"
                        >
                          {" "}
                          {/*sunita-task-3271-added col and it's data as per requirement */}
                          {this.state.tableSearchText === "" ? (
                            <div>
                              {this.state.campList.map((campList) => (
                                <div
                                  style={{
                                    borderBottom: "1px solid #eee",
                                    padding: "5px 15px",
                                  }}
                                  className="campNames"
                                >
                                  {/* 4610-Nilesh Add agency camp ID i.e clientCampID */}
                                  {/* kiran-4752-removing console warning-added "#/" */}
                                  <a
                                    href="#/"
                                    className="reviewcampdata"
                                    id={campList.campID}
                                    onClick={this.displayLeads}
                                  >
                                    {campList.campID} - {campList.clientCampID} -{" "}
                                    {campList.campaignName}{" "}
                                  </a>
                                </div>
                              ))}
                            </div>
                          ) : this.state.campListSearch.length > 0 ? (
                            <div>
                              {this.state.campListSearch.map((campListSearch) => (
                                <div
                                  style={{
                                    borderBottom: "1px solid #eee",
                                    padding: "5px 15px",
                                  }}
                                  className="campNames"
                                >
                                  {/* 4610-Nilesh Add agency camp ID i.e clientCampID */}
                                  <a
                                    href="#/"
                                    className="reviewcampdata"
                                    id={campListSearch.campID}
                                    onClick={this.displayLeads}
                                  >
                                    {campListSearch.campID} -{" "}
                                    {campListSearch.clientCampID} -{" "}
                                    {campListSearch.campaignName}{" "}
                                  </a>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <center>
                              <label
                                style={{
                                  color: "red",
                                  fontSize: "medium",
                                  marginTop: "34px",
                                }}
                              >
                                No Data Exist
                              </label>
                            </center>
                          )}
                        </div>
                      </div>
  
                      {/* <br /> */}
                      {/* <div id="class one Div" class="col-sm-12 col-md-8 col-lg-9">
                <div class="card" >
                  <div className="card-body card-body2"> 
                    {/* <div> */}
                      {/*sunita-task-3271-added below code as per requirement  */}
                      {/* Rutuja Jagtap task-3879 Responsive*/}
                      <div
                        className="col-xs-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 qacampaignDetails"
                        style={{ background: "#FFFFFF", paddingTop: "20px" }}
                      >
                        {/*sunita-task-3271-added code as per requirement */}
                        <div
                          id="pleaseWait"
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            fontSize: "13px",
                            left: "400px",
                            top: "200px",
                          }}
                          className={this.state.loading}
                        ></div>
                        <div>
                        {/* //Rutuja task 5634 disabled camp info when there is no data */}
                          {this.state.leadDetails.length > 0 && this.state.key === 2 && (
                          this.state.campDetails.map((details) => {
                            return (
                              <div>
                                {/*sunita-task-3271-added below label css changes for campID,campname,start date,end date and type as per new requirement for alignment*/}
                                <div
                                  className="row"
                                  style={{ marginTop: "-9px" }}
                                >
                                  {/* <div className="col-sm-12 col-md-6 col-lg-8"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Campaign ID :
                                    </label>{" "}
                                    &nbsp;<span>{details.campID}</span>
                                  </div>
                                  {/* </div> */}
                                  {/* <div className="row"> */}
                                  {/* <div className="col-sm-12 col-md-8 col-lg-8"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-8">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Campaign Name :{" "}
                                    </label>
                                    &nbsp;
                                    <span className="reviewcampdata1">
                                      {" "}
                                      {/* {details.campaignName} */}
                                       {/* Anshul-5960: added tooltip for showing full campaign name in tooltip */}
                                      <Tooltip placement="bottomRight" title={details.campaignName}>
                                        <span>{truncateText(details.campaignName, 16)}</span>
                                      </Tooltip>
                                    </span>
                                  </div>
                                  {/* </div> */}
  
                                  {/* <div className="row"> */}
                                  {/* <div className="col-sm-12 col-md-6 col-lg-3"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Campaign Type :
                                    </label>
                                    &nbsp;<span> {details.ABM}</span>
                                  </div>
  
                                  {/* <div className="col-sm-12 col-md-6 col-lg-3"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Start Date :
                                    </label>
                                    &nbsp;<span> {details.startDate}</span>
                                  </div>
  
                                  {/* <div className="col-sm-12 col-md-6 col-lg-3"> */}
                                  <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-4">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "black",
                                        fontWeight: "600",
                                      }}
                                    >
                                      End Date :
                                    </label>
                                    &nbsp;<span>{details.endDate}</span>
                                  </div>
                                </div>
                              </div>
                            );
                          }))}
                        </div>
  
                        <br />
  
                        <hr />
                  {/* Anshul-5960: added loader here to show in centre */}
                      <div id={this.state.loader2}></div>
                        <div className="row" style={{ marginLeft: "0px" }}>
                          <div>
                            {/*sunita-task-3271-added below changes as per new requirement screen for instructions*/}
                            <h5>
                              <span
                                style={{ fontWeight: "bold", color: "#F28C0F" }}
                              >
                                Offline Lead Review Instructions :-{" "}
                              </span>
                              <br />
                            </h5>
                            <span>
                              1. Click on <b>"Download Leads" </b> to get Lead's
                              File.
                            </span>
                            <br />
  
                            <span>
                              2. After reviewing the lead, Please update status as{" "}
                              <b> "PV ACCEPTED" OR "PV REJECTED" </b>
                              in Status column in Lead's File.
                            </span>
                          </div>
                          <div>
                            <span>
                              3. If you rejecting the lead then please{" "}
                              <b> add reason of rejection </b> in reason column in
                              Lead's File.
                            </span>
                            <br />
                            <span>
                              4. Click on <b>"Upload Lead"</b> to upload reviewed
                              Lead's File.
                            </span>
                          </div>
                        </div>
                        <br />
  
                        <div className="row">
                          <div className="col-sm-12 col-md-6 col-lg-6">
                            {/*sunita-task-3160-added column for proper alignment*/}
                            <button
                              class="btn add-button"
                              type="button"
                              onClick={this.downloadFile}
                              style={{
                                backgroundColor: "#056eb8",
                                color: "white",
                                height: "32px",
                                fontSize: "14px",
                                fontFamily: "sans-serif",
                                fontWeight: "400",
                                borderRadius: "4px",
                              }}
                              disabled={
                                this.state.leadDetails.length > 0 ? false : true
                              }
                            >
                              {/*sunita-task-3271-added  css as per requirement */}
                              <i
                                class="fa fa-cloud-download"
                                aria-hidden="true"
                              ></i>
                              &nbsp;Download Leads
                            </button>
                          </div>
                          <div className="col-sm-12 col-md-6 col-lg-6">
                            <span className="mobileCss">
                              Download Leads:{" "}
                              {this.state.getLeadCounts > 0
                                ? this.state.getLeadCounts
                                : 0}{" "}
                              &nbsp; | &nbsp; New Leads :{" "}
                              {this.state.leadDetailsCount -
                                this.state.getLeadCounts}
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-sm-12 col-md-6 col-lg-6"
                            id="lead_button1"
                          >
                            {/*sunita-task-3160-added column as per requirement */}
                            {/*sunita-task-3271-added css as per requirement */}
                            <label
                              class=" btn btn-defaulttab"
                              style={{
                                cursor:
                                  this.state.leadDetails.length > 0
                                    ? "default"
                                    : "no-drop",
                                height: "32px",
                                fontFamily: "sans-serif",
                                fontSize: "14px",
                                fontWeight: "400",
                                borderRadius: "4px",
                                backgroundColor: "transparent",
                                color: "#193D8F",
                                border: "1px solid #193D8F",
                              }}
                              disabled={
                                this.state.leadDetails.length > 0 ? false : true
                              }
                            >
                              Upload Lead
                              <input
                                disabled={
                                  this.state.leadDetails.length > 0 ? false : true
                                }
                                id="abm1"
                                key={this.state.filesData1}
                                style={{ display: "none" }}
                                type="file"
                                onChange={this.fileupload}
                              />{" "}
                              {/*-sunita-task-3271-added for file*/}
                            </label>
                            <span
                              id="fileName2"
                              style={{
                                width: "150px",
                                textOverflow: "ellipsis",
                                display: "contents",
                                cursor:
                                  this.state.leadDetails.length > 0
                                    ? "default"
                                    : "no-drop",
                              }}
                              disabled={
                                this.state.leadDetails.length > 0 ? false : true
                              }
                            >
                              No File Choosen
                            </span>
                            {/*sunita-task-3271-added as per requirement */}
                          </div>
                        </div>
  
                        <br />
                        <div class="row" style={{ marginBottom: "6px" }}>
                          {/*sunita-task-3160-added row and column as per requirement */}
                          <div className="col-xs-12 col-sm-12 col-md-8 col-lg-9 col-xl-10">
                            <span
                              style={{
                                fontWeight: "bold",
                                marginTop: "115px",
                                color: "#056eb8",
                              }}
                            >
                              Online Lead Review & Instant Status Update :-
                              <br />
                            </span>
                            <span>
                              Total Leads :{this.state.leadDetails.length}
                            </span>
                          </div>
  
                          {/* Priyanka-4633-Renaming submit button for second tab */}
                          <div className="col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 btn_Submit">
                            {/*sunita-task-3160-added button as per requirement */}
                            <button
                              className="btn add-button"
                              id="submitButtonPV"
                              onClick={this.handleSubmit}
                              disabled={
                                this.state.leadDetails.length > 0 ? false : true
                              }
                              style={{
                                align: "right",
                                paddingBottom: "6px",
                                fontFamily: "sans-serif",
                                fontSize: "14px",
                                fontWeight: "400",
                                borderRadius: "4px",
                              }}
                            >
                              Submit{" "}
                              {/*sunita-task-3271-added css as per requirement */}
                            </button>
                          </div>
  
                          {this.state.reasonErrorDisplayFlag === true ? (
                            <span style={{ color: "red", marginLeft: "2%" }}>
                              Please enter reason for Rejection
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
  
                        {/*sunita-task-3271-added some attributes as per requirement in table */}
                        {/* Sandeep-task-3441-added loader */}
                        {/* <div id={this.state.loader2}></div> */}
                        <Table
                          {...this.state.tableState}
                          columns={
                            this.state.marketingChannelFlag === true
                              ? pvLeadDetails2
                              : pvLeadDetails
                          }
                          rowClassName={"qaLeadDetails"}
                          onChange={this.onTableChange} //Nilesh-5517- Call to onTableChange function
                          class="ant-table-thead"
                          className={tableCSS}
                          dataSource={this.state.leadDetails}
                          //4562 -(as discussed with ram sir, commented the pagination for this_issue) Prod_Issue - AC, AQA, ANC, DIQA, Publisher, PQA, Advertiser -Leads Review-Leads Rejected Issue
                          //Nilesh-5517- Add pagination code below
                          pagination={{
                            pageSize: this.state.pageSize2,
                            position: "bottom",
                          }}
                          //pagination={{ pageSize: this.state.pageSize2, position: "bottom" }}
                          //loading={this.state.loading1}
                          scroll={{ x: 1300, y: 450 }}
                          bordered={true}
                        >
                          {" "}
                          {/* y:1333 - 4562 -change the table height */}
                          {/*className={tableCSS + " " + 'myFont'} >{/*sunita-task-3180-removed css as not needed*/}
                        </Table>
                        {/* Nilesh-5517- Add pagination UI code below */}
                        <div class="row">
                          <div
                            class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                            style={{
                              marginTop: "-52px",
                              marginLeft: "5px",
                              fontSize: "13px",
                              color: "#4F4F4F",
                              fontFamily: "sans-serif",
                            }}
                          >
                            &nbsp;&nbsp;&nbsp;Records per page:&nbsp;
                            <select
                              value={this.state.pageSize2}
                              onChange={this.handleChangePageSize2}
                              id="pacing1"
                              class="input-small"
                              className="form-control"
                              name="pacing"
                              style={{
                                width: "71px",
                                height: "30px",
                                display: "initial",
                                fontSize: "13px",
                                fontFamily: "sans-serif",
                                color: "#4F4F4F",
                              }}
                            >
                              {/* sunita-task-3271-added css as per requirement  */}
                              <option value="100" selected>
                                100
                              </option>
                              <option value="200">200</option>
                              <option value="300">300</option>
                            </select>
                          </div>
                        </div>
                        {/* <p> */}
                        {/* 4562 -(as discussed with ram sir, commented the pagination for this_issue) Prod_Issue - AC, AQA, ANC, DIQA, Publisher, PQA, Advertiser -Leads Review-Leads Rejected Issue */}
                        {/* sunita-task-3271-added below code for paginaion */}
                        {/* <div class="row">
                          <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style={{ marginTop: '-52px', marginLeft: "5px", fontSize: '13px', color: '#4F4F4F', fontFamily: 'sans-serif' }}>
                            &nbsp;&nbsp;&nbsp;Records per page:&nbsp;
                            <select
                              defaultValue={this.state.pageSize2}
                              onChange={this.handleChangePageSize2}
                              id="pacing1"
                              class="input-small"
                              className="form-control"
                              name="pacing" style={{ width: '71px', height: '30px', display: 'initial', fontSize: '13px', fontFamily: 'sans-serif', color: '#4F4F4F' }}> /*sunita-task-3271-added css as per requirement /
                              <option value="100" selected>100</option>
                              <option value="200" >200</option>
                              <option value="300">300</option>
                            </select>
                          </div>
                        </div> */}
                        {/* </p> */}
  
                        <br />
                        <div className="row">
                          <div
                            className="col-sm-12 col-md-6 col-lg-8"
                            style={{ textAlign: "left" }}
                          ></div>
                          <div
                            className="col-sm-12 col-md-6 col-lg-4"
                            style={{ textAlign: "end", marginBottom: "40px" }}
                          >
                            {/*sunita-task-3271-added css as per requirement */}
                            {/*sunita-task-3422-changed the id as it's giving pblm bcz same id's are given. */}
                            {/* Priyanka-4633-Renaming submit button for second tab */}
                            <button
                              className="btn  add-button"
                              id="submitButtonPV1"
                              onClick={this.handleSubmit}
                              disabled={
                                this.state.leadDetails.length > 0 ? false : true
                              }
                              style={{
                                align: "right",
                                paddingBottom: "6px",
                                fontFamily: "sans-serif",
                                fontSize: "14px",
                                fontWeight: "400",
                                borderRadius: "4px",
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                      {/* </div>{/*3rd */}
                      {/* </div>2nd */}
                      {/* </div> 1st */}
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </Tab>
            </Tabs>
             {/* //Kiran Dhainje 5958 Added below code */}
            {this.state.showNotesModal && (
              <div ref={this.notesPanelRef} className="internal-notes-wrapper">
                <div className="internal-notes-panel">
                  <button
                    type="button"
                    className="internal-notes-close"
                    onClick={this.closeNotesModal}
                    aria-label="Close internal campaign notes"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div className="internal-notes-title">
                    <div className="internal-notes-heading">
                      Internal Campaign Notes
                    </div>
                    <div className="internal-notes-subtitle">
                      Campaign ID : <span>{this.state.campID || "--"}</span>
                    </div>
                  </div>
                  <div className="internal-notes-body" ref={this.notesBodyRef}>
                    {this.state.campaignNotesHistory.length > 0 ? (
                      this.state.campaignNotesHistory
                        .slice()
                        .reverse()
                        .map((note) => {
                          const { name, initials } = this.resolveNoteUserMeta(note);
                          const timestampLabel = this.getTimestampLabel(note);
                          const timestampTitle = this.getTimestampTitle(note);
                          const isJustNow = timestampLabel === "Just now";
                          const isEdited = note.Edited_attempt > 0;
                          return (
                            <div className="internal-note-item" key={note.note_id || note.id || note.created_at}>
                              <div className="internal-note-avatar">{initials}</div>
                              <div className="internal-note-content">
                                <div className="internal-note-header">
                                  <div className="internal-note-meta">
                                    <span className="internal-note-user">{name}</span>
                                    <span
                                      className={`internal-note-time ${isJustNow ? "internal-note-time-new" : ""} ${isEdited ? "internal-note-time-edited" : ""}`}
                                      title={timestampTitle}
                                    >
                                      {timestampLabel}
                                      {isEdited }
                                    </span>
                                  </div>
                                </div>
                                <div className="internal-note-message">{note.message}</div>
                              </div>
                            </div>
                          );
                        })
                    ) : (
                      <div className="internal-notes-empty">
                        <p>No notes yet.</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <Footer />
          </div>
        </div>
      );
    }
}

qualityLeadsReview.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
  };
  
  const mapStateToProps = (state) => ({
    auth: state.auth,
  });
  export default connect(mapStateToProps, { logoutUser })(
    withRouter(qualityLeadsReview)
  );